function nextStep(currentStep) {
  document.getElementById(`step${currentStep}`).classList.remove("active");
  document.getElementById(`step${currentStep + 1}`).classList.add("active");
  updateSteps(currentStep + 1);

  if (currentStep + 1 === 3) {
    // Force reflow before accessing dimensions
    requestAnimationFrame(() => {
      const canvas = window.railCanvasInstance;
      if (canvas) {
        canvas.renderCanvas();
      }
    });
  }
}

function prevStep(currentStep) {
  document.getElementById(`step${currentStep}`).classList.remove("active");
  document.getElementById(`step${currentStep - 1}`).classList.add("active");
  updateSteps(currentStep - 1);
}

function openStep(step) {
  const currentActiveStep = document.querySelector(".form-step.active");

  if (currentActiveStep) {
    const currentStepIndex = parseInt(currentActiveStep.id.replace("step", ""));
    if (step < currentStepIndex) {
      currentActiveStep.classList.remove("active");
      document.getElementById(`step${step}`).classList.add("active");
      updateSteps(step);
    }
  }
}

function updateSteps(step) {
  $('.step').removeClass('active-tabs active-tabs-head');
  $(`#step-${step}`).addClass('active-tabs active-tabs-head');

  $('.mobile_tabs').removeClass('active-tabs');
  $(`#num${step}`).addClass('active-tabs');

  if(screen.width < 767){
      const scrollTo = `.mob_tab${step}`;
      $('html, body').animate({
          scrollTop: $(scrollTo).offset().top
      }, 100);
  }
}

function toggleActive(element) {
  // Toggle the active class on the clicked element
  element.classList.toggle("active");
}

// lightbox
function openLightbox(element) {
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.getElementById("lightbox-img");
  // If the clicked element is the SVG, get the image source from the parent
  if (element.classList.contains("open_image")) {
    lightboxImg.src = element.previousElementSibling.src; // Get the image source
  } else {
    lightboxImg.src = element.src; // Get the image source directly
  }
  lightbox.classList.add("active"); // Show the lightbox
  document.body.classList.add("open_lightbox");
}

function closeLightbox() {
  const lightbox = document.getElementById("lightbox");
  lightbox.classList.remove("active"); // Hide the lightbox
  document.body.classList.remove("open_lightbox");
}

// Show sidebar on clicking the mobile file support button
$(".mobile_file_support").each(function () {
  $(this).on("click", function () {
    const $sidebarContent = $(".sidebar_grid");
    $sidebarContent.addClass("show_sidebar");

    // Add class to body when sidebar is shown
    if ($sidebarContent.hasClass("show_sidebar")) {
      $("body").addClass("show_sidebar_content");
    }
  });
});

// Hide sidebar on clicking the close button
$(".close_sidebar").on("click", function () {
  const $sidebarContent = $(".sidebar_grid");
  $sidebarContent.removeClass("show_sidebar");

  // Remove class from body when sidebar is hidden
  $("body").removeClass("show_sidebar_content");
});


/* --- Railing configurator --- start */

class BaseCanvas {
  constructor() {
    this.canvas = document.querySelector("#drawingCanvas");
    this.zoomInButton = document.querySelector("#zoomIn");
    this.zoomOutButton = document.querySelector("#zoomOut");
    if (!this.canvas) return console.error("Canvas element not found!");
    this.ctx = this.canvas.getContext("2d");

    this.shapeSelector = document.querySelectorAll(
      'input[name="productTypeTemplate"]'
    );
    this.inputs = document.querySelectorAll('input[type="number"]');
    
    this.scale = this.getDynamicScale();
    this.zoomCounter = 0;
    this.pendingZoom = null;
    this.debounceTimer = null;
    
    this.maxLength = 4000;

    this.blueColor = "#055EC1";
    this.glassShade = "rgba(234, 241, 243, 0.7)";
    this.grayColor = "#B5B1AC";
    this.borderColor = "#1f1f1f";
    this.lightGray = "#707070";
    this.blackColor = "#000";
    this.outerTPColor = "#000";
    this.darkBlueColor = "#004057";

    this.gridOffset = { x: 0, y: 0 };

    // Bind once
    this.onShapeChange = this.onShapeChange.bind(this);
    this.zoomInHandler = this.zoomIn.bind(this);
    this.zoomOutHandler = this.zoomOut.bind(this);
    this.startDragHandler = this.startDrag.bind(this);
    this.dragCanvasHandler = this.dragCanvas.bind(this);
    this.stopDragHandler = this.stopDrag.bind(this);

    this.initCanvasEvents();
  }

  initCanvasEvents() {
    this.zoomInButton.addEventListener("click", this.zoomInHandler);
    this.zoomOutButton.addEventListener("click", this.zoomOutHandler);

    this.shapeSelector.forEach((radio) => {
      radio.removeEventListener("change", this.onShapeChange);
      radio.addEventListener("change", this.onShapeChange);
    });

    ["touchstart", "mousedown"].forEach((event) =>
      this.canvas.addEventListener(event, this.startDragHandler)
    );
    ["touchmove", "mousemove"].forEach((event) =>
      this.canvas.addEventListener(event, this.dragCanvasHandler)
    );
    ["touchend", "mouseup"].forEach((event) =>
      this.canvas.addEventListener(event, this.stopDragHandler)
    );
  }

  destroy() {
    this.shapeSelector.forEach((radio) => {
      radio.removeEventListener("change", this.onShapeChange);
    });

    this.zoomInButton.removeEventListener("click", this.zoomInHandler);
    this.zoomOutButton.removeEventListener("click", this.zoomOutHandler);

    ["touchstart", "mousedown"].forEach((event) =>
      this.canvas.removeEventListener(event, this.startDragHandler)
    );
    ["touchmove", "mousemove"].forEach((event) =>
      this.canvas.removeEventListener(event, this.dragCanvasHandler)
    );
    ["touchend", "mouseup"].forEach((event) =>
      this.canvas.removeEventListener(event, this.stopDragHandler)
    );

    window.removeEventListener("resize", this.updateScales);
  }

  setupCommonListeners({ mode, renderCallback }) {
    if (window.activeMode !== mode) return;

    window.addEventListener("resize", this.updateScales.bind(this));

    const inputIds = [
      "overall-length-1",
      "overall-length-2",
      "overall-length-3",
      "num_panels_span_1",
      "num_panels_span_2",
      "num_panels_span_3",
    ];

    inputIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        el.addEventListener("change", (e) => {
          this.validateInput(e.target);
          renderCallback.call(this); // Ensure correct `this` context
        });
      }
    });
  }

  get smallGridSize() {
    if(this.isDetailView) {
      return 38;
    }
    return 25;
  }

  get largeGridSize() {
    if(this.isDetailView) {
      return 380;
    }
    return 250;
  }

  get inverseScale() {
    return 1 / this.scale;
  }

  get selectedShape() {
    const selected = [
      ...document.querySelectorAll('input[name="productTypeTemplate"]'),
    ].find((r) => r.checked);
    return selected?.value || "inline";
  }

  get selectedRailingHeight() {
    const input = document.querySelector('input[name="railingHeight"]:checked');
    return input ? parseFloat(input.value) : 36;
  }

  get isDetailView() {
    return window.activeMode === "detail";
  }

  get activeView() {
    return window.activeMode;
  }

  get shapeInputs() {
    const parseInput = (id, defaultValue = 0) => {
      const value = parseFloat(document.getElementById(id)?.value);
      return isNaN(value) ? defaultValue : value;
    };

    const parsePanelSelect = (id, fallback = 4) => {
      const select = document.getElementById(id);
      const option = select?.selectedOptions[0];
      const panels = parseInt(option?.value) || fallback;
      const size = parseFloat(option?.dataset.panelSize) || 48.813;
      return { panels, size };
    };

    const selectedShape = this.selectedShape;

    const inline = () => {
      const { panels, size } = parsePanelSelect("num_panels_span_1");
      return [parseInput("overall-length-1", 400), panels, size];
    };

    const l_shape = () => {
      const span1 = parsePanelSelect("num_panels_span_1");
      const span2 = parsePanelSelect("num_panels_span_2");
      return [
        parseInput("overall-length-1", 300),
        parseInput("overall-length-2", 300),
        span1.panels,
        span2.panels,
        span1.size,
        span2.size,
      ];
    };

    const u_shape = () => {
      const span1 = parsePanelSelect("num_panels_span_1");
      const span2 = parsePanelSelect("num_panels_span_2");
      const span3 = parsePanelSelect("num_panels_span_3");
      return [
        parseInput("overall-length-1", 200),
        parseInput("overall-length-2", 250),
        parseInput("overall-length-3", 200),
        span1.panels,
        span2.panels,
        span3.panels,
        span1.size,
        span2.size,
        span3.size,
      ];
    };

    const result = {
      inline,
      l_shape,
      u_shape,
    }[selectedShape]?.();

    return result && result.every((val) => !isNaN(val)) ? result : null;
  }

  get spanScale() {
    return this.getDynamicSpanScale();
  }

  get canvasWidth() {
    const outerDiv = document.querySelector(".canvas_graph");
    const width = outerDiv?.getBoundingClientRect().width || 900;
    return width;
  }

  get canvasHeight() {
    const outerDiv = document.querySelector(".canvas_graph");
    const height = outerDiv?.getBoundingClientRect().height || 500;
    return height;
  }

  get panelScale() {
    const spanKey = this._overrideSpanKey || this.activeSpanKey;
    return this.getPanelScale(spanKey);
  }

  get panelDimensions() {
    const inputs = this.shapeInputs || [];
    const spanKey = this.activeSpanKey;
    const shape = this.selectedShape;

    let length = 0,
      panels = 0,
      panelSize = 48.813;
    let totalPanels = 0;
    let startIndex = 0;

    if (shape === "inline") {
      totalPanels = inputs[1] || 0;
      if (spanKey === "A")
        [length, panels, panelSize] = [inputs[0], inputs[1], inputs[2]];
    } else if (shape === "l_shape") {
      totalPanels = (inputs[2] || 0) + (inputs[3] || 0);
      if (spanKey === "A") {
        [length, panels, panelSize] = [inputs[0], inputs[2], inputs[4]];
        startIndex = 0;
      }
      if (spanKey === "B") {
        [length, panels, panelSize] = [inputs[1], inputs[3], inputs[5]];
        startIndex = inputs[2] || 0; // Span A panels
      }
    } else if (shape === "u_shape") {
      totalPanels = (inputs[3] || 0) + (inputs[4] || 0) + (inputs[5] || 0);
      if (spanKey === "A") {
        [length, panels, panelSize] = [inputs[0], inputs[3], inputs[6]];
        startIndex = 0;
      }
      if (spanKey === "B") {
        [length, panels, panelSize] = [inputs[1], inputs[4], inputs[7]];
        startIndex = inputs[3] || 0;
      }
      if (spanKey === "C") {
        [length, panels, panelSize] = [inputs[2], inputs[5], inputs[8]];
        startIndex = (inputs[3] || 0) + (inputs[4] || 0);
      }
    }

    return { length, panels, panelSize, totalPanels, startIndex };
  }

  clearCanvas() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  setupViewSwitching() {
    if (window._viewSwitchingInitialized) return;
    window._viewSwitchingInitialized = true;
    const destroyOldInstance = () => {
      if (window.drawerInstance?.destroy) {
        window.drawerInstance.destroy();
      }
    };
    
    document.querySelector(".simple_view")?.addEventListener("click", () => {
      destroyOldInstance();
      window.activeMode = "simple";
      window.drawerInstance = null;
      window.drawerInstance = new RailingConfiguratorCanvas(
        "drawingCanvas"
      );
    });

    document.querySelector(".top_view")?.addEventListener("click", () => {
      destroyOldInstance();
      window.activeMode = "top";
      window.drawerInstance = null;
      window.drawerInstance = new TopViewDrawer("drawingCanvas");
    });

    document.querySelector(".detail_view")?.addEventListener("click", () => {
      destroyOldInstance();
      window.activeMode = "detail";
      window.drawerInstance = null;
      window.drawerInstance = new DetailViewDrawer("drawingCanvas");
    });

    ["A", "B", "C"].forEach((key) => {
      document
        .querySelector(`.sidePanelView-${key}`)
        ?.addEventListener("click", () => {
          destroyOldInstance();
          window.activeMode = "side";
          window.drawerInstance = null;
          window.drawerInstance = new FrontPanelDrawer("drawingCanvas", key);
        });
    });
  }

  validateInput(input) {
    const { maxLength } = this;
    const value = Math.min(parseInt(input.value) || 0, maxLength);
    input.value = value;
    this.showTooltip(
      input,
      value === maxLength ? `The maximum allowed value ${maxLength}.` : ""
    );
  }

  getMaxSpanLength(...lengths) {
    return Math.max(...lengths.filter(val => typeof val === 'number' && !isNaN(val)));
  }

  startDrag(e) {
    e.preventDefault();
    this.isDragging = true;
    this.canvas.style.cursor = "grabbing";

    if (this.isDragging || this.isZooming) {
      this.ctx.imageSmoothingEnabled = false;
    }

    if (e.type === "touchstart") {
      this.dragStart = {
        x: e.touches[0].clientX - this.gridOffset.x,
        y: e.touches[0].clientY - this.gridOffset.y,
      };
    } else {
      this.dragStart = {
        x: e.offsetX - this.gridOffset.x,
        y: e.offsetY - this.gridOffset.y,
      };
    }
  }

  dragCanvas(e) {
    if (this.isDragging) {
      if (e.type === "touchmove") {
        this.gridOffset = {
          x: e.touches[0].clientX - this.dragStart.x,
          y: e.touches[0].clientY - this.dragStart.y,
        };
      } else {
        this.gridOffset = {
          x: e.offsetX - this.dragStart.x,
          y: e.offsetY - this.dragStart.y,
        };
      }
      if (window.activeMode === "simple") {
        window.drawerInstance.renderCanvas();
      } else if (window.activeMode === "top") {
        window.drawerInstance.topViewRender();
      } 
      else if (window.activeMode === "detail") {
        window.drawerInstance.detailViewRender();
      } 
      else if (window.activeMode === "side") {
        window.drawerInstance.sideViewRender();
      }
    }
  }

  stopDrag() {
    this.isDragging = false;
    this.canvas.style.cursor = "grab";
    this.ctx.imageSmoothingEnabled = true;

    if (window.activeMode === "top") {
      window.drawerInstance.topViewRender();
    } else if (window.activeMode === "detail") {
      window.drawerInstance.detailViewRender();
    } else if (window.activeMode === "side") {
        window.drawerInstance.sideViewRender();
    }
  }

  getDynamicScale() {
    if (window.innerWidth >= 1024) return 1.5;
    if (window.innerWidth >= 967) return 1.1;
    if (window.innerWidth >= 768) return 1;
    if (window.innerWidth >= 567) return 0.9;
    if (window.innerWidth >= 468) return 0.7;
    return 0.6; // Default for very small screens
  }

  getDynamicSpanScale() {
    if (window.innerWidth >= 1024) return 1;
    if (window.innerWidth >= 967) return 0.8;
    if (window.innerWidth >= 768) return 0.7;
    return 0.6;
  }

  onShapeChange(event) {
    this.clearCanvas();
    this.resetCanvasPosition();

    if (window.drawerInstance?.destroy) {
      window.drawerInstance.destroy();
    }

    window.activeMode = "simple";
    window.drawerInstance = new RailingConfiguratorCanvas("drawingCanvas");
    
    window._viewSwitchingInitialized = false;
    this.setupViewSwitching();
    
    this.onAfterShapeChange();
  }

  onAfterShapeChange() {
    // empty hook
  }

  resetCanvasPosition() {
    this.gridOffset = {
      x: 0,
      y: 0,
    };
  }

  drawGrid() {
    const { ctx, scale, gridOffset, canvas } = this;
    const smallGridSize = this.smallGridSize * scale,
      largeGridSize = this.largeGridSize * scale;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.drawGridLines(smallGridSize, "#ddd", 0.8);
    this.drawGridLines(largeGridSize, "#ccc", 1.5);
  }

  drawGridLines(gridSize, color, lineWidth) {
    const { ctx, gridOffset, canvas } = this;
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;

    for (let i = gridOffset.x % gridSize; i < canvas.width; i += gridSize) {
      ctx.beginPath();
      ctx.moveTo(i, 0);
      ctx.lineTo(i, canvas.height);
      ctx.stroke();
    }

    for (let i = gridOffset.y % gridSize; i < canvas.height; i += gridSize) {
      ctx.beginPath();
      ctx.moveTo(0, i);
      ctx.lineTo(canvas.width, i);
      ctx.stroke();
    }
  }

  getBasePosition(shape) {
    const width = window.innerWidth;

    const getInlinePosition = () => {
      if (width >= 1024) return { x: 160, y: 200 };
      if (width >= 967) return { x: 200, y: 200 };
      if (width >= 768) return { x: 280, y: 298 };
      if (width >= 673) return { x: 330, y: 298 };
      if (width >= 567) return { x: 370, y: 298 };
      if (width >= 468) return { x: 460, y: 398 };
      return { x: 600, y: 498 };
    };

    const getLShapePosition = () => {
      if (width >= 1024 || width >= 967) return { x: 300, y: 350 };
      if (width >= 768) return { x: 456, y: 398 };
      if (width >= 567) return { x: 476, y: 454 };
      if (width >= 468) return { x: 706, y: 594 };
      return { x: 756, y: 594 };
    };

    const getUShapePosition = () => {
      if (width >= 1024) return { x: 304, y: 324 };
      if (width >= 967) return { x: 370, y: 396 };
      if (width >= 768) return { x: 460, y: 398 };
      if (width >= 567) return { x: 478, y: 474 };
      if (width >= 468) return { x: 630, y: 494 };
      return { x: 760, y: 594 };
    };

    switch (shape) {
      case "inline":
        return getInlinePosition();
      case "l_shape":
        return getLShapePosition();
      case "u_shape":
        return getUShapePosition();
      default:
        return { x: 646, y: 594 };
    }
  }

  getSideViewPosition() {
    const width = this.canvasWidth;

    if (width >= 900) return { x: 50, y: 170 };
    if (width >= 800) return { x: 100, y: 220 };
    if (width >= 750) return { x: 100, y: 250 };
    if (width >= 700) return { x: 130, y: 250 };
    if (width >= 650) return { x: 150, y: 300 };
    if (width >= 600) return { x: 180, y: 300 };
    if (width >= 550) return { x: 220, y: 300 };
    if (width >= 500) return { x: 250, y: 300 };
    if (width >= 450) return { x: 350, y: 400 };
    if (width >= 400) return { x: 400, y: 400 };
    if (width >= 350) return { x: 550, y: 450 };
    if (width >= 300) return { x: 600, y: 450 };
    return { x: 600, y: 498 };
  }

  getDetailViewBP(shape) {
    const width = this.canvasWidth;

    /* x, y belongs to base position for top and detail view */    
    const getDetailInlinePosition = () => {
      if (width >= 900) return { x: 35, y: 150 };
      if (width >= 800) return { x: 90, y: 220 };
      if (width >= 700) return { x: 120, y: 270 };
      if (width >= 600) return { x: 170, y: 300 };
      if (width >= 500) return { x: 210, y: 290 };
      if (width >= 450) return { x: 380, y: 310 };
      if (width >= 400) return { x: 440, y: 370 };
      if (width >= 300) return { x: 600, y: 410 };
      return { x: 600, y: 460 };
    };

    const getDetailLShapePosition = () => {
      const breakpoints = [
        [900, { x: 400, y: 300 }],
        [850, { x: 540, y: 450 }],
        [800, { x: 580, y: 450 }],
        [750, { x: 560, y: 430 }],
        [700, { x: 550, y: 430 }],
        [650, { x: 580, y: 420 }],
        [600, { x: 610, y: 480 }],
        [550, { x: 610, y: 450 }],
        [500, { x: 610, y: 450 }],
        [450, { x: 730, y: 530 }],
        [400, { x: 750, y: 550 }],
        [350, { x: 850, y: 650 }],
        [300, { x: 850, y: 650 }],
      ];
    
      for (const [minWidth, config] of breakpoints) {
        if (width >= minWidth) return config;
      }
    
      return {  x: 900, y: 650 };
    };

    const getDetailUShapePosition = () => {
      const breakpoints = [
        [900, { x: 400, y: 360 }],
        [800, { x: 550, y: 450 }],
        [700, { x: 600, y: 470 }],
        [650, { x: 600, y: 500 }],
        [600, { x: 640, y: 500 }], 
        [500, { x: 600, y: 480 }],
        [400, { x: 750, y: 570 }],
        
        [300, { x: 850, y: 600 }],
      ];
    
      for (const [minWidth, config] of breakpoints) {
        if (width >= minWidth) return config;
      }
    
      return { x: 900, y: 650 };
    };


    switch (shape) {
      case "inline":
        return getDetailInlinePosition();
      case "l_shape":
        return getDetailLShapePosition();
      case "u_shape":
        return getDetailUShapePosition();
      default:
        return {
          x: 0,
          y: 70
        };
    }
  }

  getSpanScaleFactor(length) {
    const w = this.canvasWidth;
    const ratios = [
      [900, 0.30],
      [850, 0.35],
      [800, 0.40],
      [750, 0.45],
      [700, 0.45],
      [650, 0.45],
      [600, 0.50],
      [500, 0.50],
      [400, 0.60],
      [300, 0.60],
      [0, 0.60],
    ];
    const r = ratios.find(([min]) => w >= min)[1];
    if(this.isDetailView && (this.selectedShape == 'l_shape' || this.selectedShape == 'u_shape')) {
      return (w * r) / length * 0.8;
    } else if((this.isDetailView || this.activeView == 'top' || this.activeView == 'inline') && this.selectedShape == 'inline') {
      return (w * r) / length * 2;
    }
    return (w * r) / length;
  }

  // Function to draw span line and panels
  drawSpanWithPanels(points, numPanels, options = {}) {
    let {
      strokeStyle = this.blackColor,
      fillStyle = this.glassShade,
      borderWidth = this.inverseScale * 0.7,
      cornerRadius = 1,
      panelHWFactor = 1,
      trimFirstPanel = false,
      trimLastPanel = false,
      trimAmount = 25 * this.scale,
    } = options;

    const gap = this.panelScale * 1.6;
    const totalLength = Math.hypot(
      points[1].x - points[0].x,
      points[1].y - points[0].y
    );
    const segmentLength = (totalLength - (numPanels - 1) * gap) / numPanels;

    const dx = points[1].x - points[0].x;
    const dy = points[1].y - points[0].y;
    const len = totalLength;

    const ux = dx / len;
    const uy = dy / len;

    this.drawSpanBackground(points);

    for (let i = 0; i < numPanels; i++) {
      let currentLength = segmentLength;
      let startOffset = 0;

      if (i === 0 && trimFirstPanel) {
        startOffset = trimAmount;
        currentLength -= trimAmount;
      } else if (i === numPanels - 1 && trimLastPanel) {
        currentLength -= trimAmount;
      }

      const distance = i * (segmentLength + gap) + startOffset;

      const startX = points[0].x + ux * distance;
      const startY = points[0].y + uy * distance;
      const endX = startX + ux * currentLength;
      const endY = startY + uy * currentLength;

      const panelSize = endX - startX || panelHWFactor;
      const panelHeight = endY - startY || panelHWFactor;

      this.ctx.fillStyle = fillStyle;
      this.ctx.strokeStyle = strokeStyle;

      const signX = Math.sign(panelSize);
      const signY = Math.sign(panelHeight);
      const bevelSize = Math.min(
        cornerRadius * this.scale * 0.2,
        Math.abs(panelSize) / 2,
        Math.abs(panelHeight) / 2
      );

      const right = startX + panelSize;
      const bottom = startY + panelHeight;

      this.ctx.beginPath();
      this.ctx.moveTo(startX + bevelSize * signX, startY);
      this.ctx.lineTo(right - bevelSize * signX, startY);
      this.ctx.lineTo(right, startY + bevelSize * signY);
      this.ctx.lineTo(right, bottom - bevelSize * signY);
      this.ctx.lineTo(right - bevelSize * signX, bottom);
      this.ctx.lineTo(startX + bevelSize * signX, bottom);
      this.ctx.lineTo(startX, bottom - bevelSize * signY);
      this.ctx.lineTo(startX, startY + bevelSize * signY);
      this.ctx.closePath();

      this.ctx.fill();
      this.ctx.lineWidth = borderWidth * this.scale;
      this.ctx.stroke();
    }
  }

  drawSpanBackground(points) {
    const ctx = this.ctx;
    ctx.strokeStyle = "#FFF";
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    ctx.lineTo(points[1].x, points[1].y);
    ctx.stroke();
  }

  // Functions to draw points 1,2, 3 and 4 on corners of span lines
  drawPointsAroundLine(points) {
    const ctx = this.ctx;
    const scale = this.scale;
    const isTopOrDetail = this.activeView === 'top' || this.activeView === 'detail';
    const isInline = this.selectedShape === 'inline';
  
    const fb_scale = isTopOrDetail
      ? this.panelScale * (isInline ? 0.3 : 0.6)
      : scale;
  
    const offset = isTopOrDetail && !isInline ? 12 : 10;
    const fontSize = fb_scale * 10;
    const squareSize = fontSize * 1.6;
    const borderRadius = 5 * fb_scale;
  
    const offsets = [
      { x: -offset * fb_scale, y: offset * fb_scale },
      { x: offset * fb_scale, y: offset * fb_scale },
      { x: offset * fb_scale, y: -offset * fb_scale },
      { x: -offset * fb_scale, y: -offset * fb_scale },
    ];
  
    ctx.lineWidth = 1;
    ctx.font = `${fontSize}px Arial`;
    ctx.strokeStyle = this.grayColor;
  
    points.forEach((pt, i) => {
      const { x, y } = offsets[i] || { x: 0, y: 0 };
      const adjX = pt.x + x;
      const adjY = pt.y + y;
  
      ctx.fillStyle = "#FFF";
      this.drawRoundedRect(
        adjX - squareSize / 2,
        adjY - squareSize / 2,
        squareSize,
        squareSize,
        borderRadius
      );
  
      ctx.fillStyle = this.blackColor;
      const label = `${i + 1}`;
      ctx.fillText(label, adjX - ctx.measureText(label).width / 2, adjY + fontSize / 3);
    });
  }

  // Helper Function to draw points 1,2, 3 and 4 on corners of span lines
  drawRoundedRect(x, y, width, height, radius) {
    const ctx = this.ctx;
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }

  // function to print text
  drawText(
    text,
    x,
    y,
    align = "center",
    baseline = "middle",
    rotate = 0,
    fontSize = null
  ) {
    this.ctx.save();
    this.ctx.translate(x, y);
    this.ctx.rotate(rotate);
    this.ctx.textAlign = align;
    this.ctx.textBaseline = baseline;
    this.ctx.fillStyle = this.blackColor;

    const scaledFontSize = fontSize !== null ? fontSize : 8 * this.panelScale;
    this.ctx.font = `${scaledFontSize}px sans-serif`;

    this.ctx.fillText(text, 0, 0);
    this.ctx.restore();
  }

  showTooltip(input, message) {
    const combineDiv = input.closest(".combine_div");
    if (!combineDiv) return;

    const existingTooltip = combineDiv.nextElementSibling;
    if (existingTooltip && existingTooltip.classList.contains("tooltip")) {
      existingTooltip.remove();
    }

    // Create tooltip
    const tooltip = document.createElement("span");
    tooltip.classList.add("tooltip");
    tooltip.textContent = message;
    tooltip.style.display = "inline-block";
    tooltip.style.marginBottom = "10px";
    tooltip.style.width = "100%";
    tooltip.style.color = "#FF6363";

    // Insert tooltip just after this combineDiv
    combineDiv.insertAdjacentElement("afterend", tooltip);

    setTimeout(() => {
      tooltip.remove();
    }, 3000);
  }

  updateScales() {
    this.scale = this.getDynamicScale();
    this.setCanvasSize();
  }

  setCanvasSize() {
    const container = this.canvas.parentElement;
    const containerWidth = container.offsetWidth;

    const aspectRatio = 800 / 600;
    const newHeight = containerWidth / aspectRatio;

    this.canvas.width = containerWidth;
    this.canvas.height = newHeight;
  }

  resizeCanvas() {
    this.setCanvasSize();
    this.drawGrid();
  }

  zoomIn() {
    this.zoomCounter++;
    this.scheduleZoomApply();
  }
  
  zoomOut() {
    this.zoomCounter--;
    this.scheduleZoomApply();
  }
  
  scheduleZoomApply() {
    clearTimeout(this.debounceTimer);
  
    // Debounce logic: wait 150ms after last click before applying zoom
    this.debounceTimer = setTimeout(() => {
      const factor = Math.pow(1.2, this.zoomCounter);
      this.applyZoom(factor);
      this.zoomCounter = 0;
    }, 100);
  }

  applyZoom(factor) {
    const centerX = this.canvas.width / 2;
    const centerY = this.canvas.height / 2;
  
    const newScale = this.scale * factor;
  
    this.gridOffset.x = centerX - (centerX - this.gridOffset.x) * (newScale / this.scale);
    this.gridOffset.y = centerY - (centerY - this.gridOffset.y) * (newScale / this.scale);
  
    this.scale = newScale;
  
    this.renderActiveMode(); 
  }

  renderActiveMode() {
    const mode = window.activeMode;
    const drawer = window.drawerInstance;
  
    const fn = {
      simple: 'renderCanvas',
      top: 'topViewRender',
      detail: 'detailViewRender',
      side: 'sideViewRender'
    }[mode];
  
    fn && drawer?.[fn]?.();
  }
  
  // side glass panels panelScale
  getPanelScale(spanKey = this.activeSpanKey) {
    const inputs = this.shapeInputs;
    if (!inputs) return this.scale;
  
    let maxLength = 0;
    
    if(this.isDetailView || this.activeView == 'top') {
      if (this.selectedShape === "inline") {
        maxLength = inputs[0];
      } else if (this.selectedShape === "l_shape") {
        maxLength = Math.max(inputs[0], inputs[1]);
      } else if (this.selectedShape === "u_shape") {
        maxLength = Math.max(inputs[0], inputs[1], inputs[2]);
      }
  
      const globalScaleFactor = this.getSpanScaleFactor(maxLength);
      return this.scale * globalScaleFactor;
    }

    // Fallback for non-detail views
    let length = this.panelDimensions.length;
    const spanScale = this.getSpanScaleFactor(length);
    return this.scale * spanScale * 1.9;
  }


}

class RailingConfiguratorCanvas extends BaseCanvas {
  constructor(canvasId) {
    super();
    this.renderCanvas();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.setupCommonListeners({
      mode: "simple",
      renderCallback: this.renderCanvas,
    });
  }

  onAfterShapeChange() {
    this.setupEventListeners();
  }

  renderCanvas() {
    this.clearCanvas();
    this.drawShape();
  }

  drawShape() {
    const inputs = this.shapeInputs;
    this.drawGrid();
    if (inputs) {
      if (this.selectedShape === "inline") {
        const [lengthA, panelsA] = inputs;
        this.drawInlineShape(lengthA, panelsA);
      } else if (this.selectedShape === "l_shape") {
        const [lengthAL, lengthBL, panelsAL, panelsBL] = inputs;
        this.drawLShape(lengthAL, lengthBL, panelsAL, panelsBL);
      } else if (this.selectedShape === "u_shape") {
        const [lengthAU, lengthBU, lengthCU, panelsAU, panelsBU, panelsCU] =
          inputs;
        this.drawUShape(
          lengthAU,
          lengthBU,
          lengthCU,
          panelsAU,
          panelsBU,
          panelsCU
        );
      }
    }
  }

  drawInlineShape(lengthA, panelsA) {
    const { scale, gridOffset } = this;
    const basePosition = this.getBasePosition("inline");
    let baseOffsetX = 130 * scale;

    let baseX = basePosition.x * scale + gridOffset.x;
    let baseY = basePosition.y * scale + gridOffset.y;

    if (this.canvasWidth > 500) {
      baseX = basePosition.x * scale + gridOffset.x - baseOffsetX;
    }

    let spanScaleFactor = this.getSpanScaleFactor(lengthA);

    const adjustedLengthA = lengthA * scale * spanScaleFactor * 2;

    const points = [
      { x: baseX, y: baseY },
      { x: baseX + adjustedLengthA, y: baseY },
    ];

    const spanPoints = [[points[0], points[1]]];

    // Draw elements
    this.drawPointsAroundLine(points);

    this.activeSpanKey = 'A';
    
    this.drawSpanWithPanels(spanPoints[0], panelsA, {
      strokeStyle: this.blackColor,
      fillStyle: this.glassShade,
      borderWidth: this.inverseScale * 0.9,
      cornerRadius: 1,
      panelHWFactor: 0.7 * scale,
    });
    
    const labelX = (points[0].x + points[1].x) / 2;
    const labelY = baseY + 15 * scale;
    this.drawText(
      `Span A: ${lengthA}"`,
      labelX,
      labelY,
      "center",
      "middle",
      0,
      9 * scale
    );

    return points;
  }

  drawLShape(lengthAL, lengthBL, panelsAL, panelsBL) {
    let { scale, gridOffset } = this;
    const basePosition = this.getBasePosition("l_shape");

    let baseX = basePosition.x * scale + gridOffset.x;
    let baseY = basePosition.y * scale + gridOffset.y;

    const maxLength = Math.max(lengthAL, lengthBL);

    let spanScaleFactor = this.getSpanScaleFactor(maxLength);

    const adjustedLengthA = lengthAL * scale * spanScaleFactor;
    const adjustedLengthB = lengthBL * scale * spanScaleFactor;

    // Coordinates for the L-shape
    const points = [
      { x: baseX - adjustedLengthA, y: baseY }, // Start of Span A
      { x: baseX + adjustedLengthA, y: baseY }, // End of Span A
      { x: baseX + adjustedLengthA, y: baseY - adjustedLengthB }, // End of Span B
    ];

    // Define spans for panels
    const spanPoints = [
      [points[0], points[1]],
      [points[1], points[2]],
    ];

    // Draw spans and panels for each span
    this.activeSpanKey = 'A';
    this.drawSpanWithPanels(spanPoints[0], panelsAL, {
      strokeStyle: this.blackColor,
      fillStyle: this.glassShade,
      borderWidth: this.inverseScale * 0.9,
      cornerRadius: 1,
      panelHWFactor: 0.9 * scale,
    });

    this.activeSpanKey = 'B';
    this.drawSpanWithPanels(spanPoints[1], panelsBL, {
      strokeStyle: this.blackColor,
      fillStyle: this.glassShade,
      borderWidth: this.inverseScale * 0.9,
      cornerRadius: 1,
      panelHWFactor: 0.9 * scale,
    });

    const labelA_X = (points[0].x + points[1].x) / 2;
    const labelA_Y = baseY + 15 * scale;
    this.drawText(
      `Span A: ${lengthAL}"`,
      labelA_X,
      labelA_Y,
      "center",
      "middle",
      0,
      9 * scale
    );

    const labelB_X = points[1].x + 15 * scale;
    const labelB_XOffset = panelsBL < 2 ? 10 * scale : 0 * scale;
    const labelB_Y = (points[1].y + points[2].y) / 2;
    this.drawText(
      `Span B: ${lengthBL}"`,
      labelB_X + labelB_XOffset,
      labelB_Y,
      "center",
      "middle",
      Math.PI / 2,
      9 * scale
    );

    // Draw number points around lines
    this.drawPointsAroundLine(points);
  }

  drawUShape(lengthAU, lengthBU, lengthCU, panelsAU, panelsBU, panelsCU) {
    let { scale, gridOffset } = this;
    let spanScaleFactor = this.getSpanScaleFactor(
      Math.max(lengthAU, lengthBU, lengthCU)
    );
    const basePosition = this.getBasePosition("u_shape");

    // 1. Calculate adjusted span lengths
    const adjustedLengthA = lengthAU * scale * spanScaleFactor;
    const adjustedLengthB = lengthBU * scale * spanScaleFactor;
    const adjustedLengthC = lengthCU * scale * spanScaleFactor;

    // 2. Base position of U-shape in the canvas
    let baseX = basePosition.x * scale + gridOffset.x;
    let baseY = basePosition.y * scale + gridOffset.y;

    // 3. Define points for the U shape
    const points = [
      { x: baseX - adjustedLengthA, y: baseY }, // Span A start
      { x: baseX + adjustedLengthA, y: baseY }, // Span A end / B start
      { x: baseX + adjustedLengthA, y: baseY - adjustedLengthB }, // Span B end / C start
      {
        x: baseX + adjustedLengthA - 2 * adjustedLengthC,
        y: baseY - adjustedLengthB,
      }, // Span C end
    ];

    const spanPoints = [
      [points[0], points[1]], // Span A
      [points[1], points[2]], // Span B
      [points[2], points[3]], // Span C
    ];

    // Draw spans and panels
    this.activeSpanKey = 'A';
    this.drawSpanWithPanels(spanPoints[0], panelsAU, {
      strokeStyle: this.blackColor,
      fillStyle: this.glassShade,
      borderWidth: this.inverseScale * 0.9,
      cornerRadius: 1,
      panelHWFactor: 0.9 * scale,
    });

    this.activeSpanKey = 'B';
    this.drawSpanWithPanels(spanPoints[1], panelsBU, {
      strokeStyle: this.blackColor,
      fillStyle: this.glassShade,
      borderWidth: this.inverseScale * 0.9,
      cornerRadius: 1,
      panelHWFactor: 0.9 * scale,
    });

    this.activeSpanKey = 'C';
    this.drawSpanWithPanels(spanPoints[2], panelsCU, {
      strokeStyle: this.blackColor,
      fillStyle: this.glassShade,
      borderWidth: this.inverseScale * 0.9,
      cornerRadius: 1,
      panelHWFactor: 0.9 * scale,
    });

    // Draw span labels using drawText
    const labelA_X = (points[0].x + points[1].x) / 2;
    const labelA_Y = baseY + 20 * scale;
    this.drawText(
      `Span A: ${lengthAU}"`,
      labelA_X,
      labelA_Y,
      "center",
      "middle",
      0,
      9 * scale
    );

    const labelB_X = points[1].x + 20 * scale;
    const labelB_Y = (points[1].y + points[2].y) / 2;
    this.drawText(
      `Span B: ${lengthBU}"`,
      labelB_X,
      labelB_Y,
      "center",
      "middle",
      Math.PI / 2,
      9 * scale
    );

    const labelC_X = (points[2].x + points[3].x) / 2;
    const labelC_Y = points[2].y - 20 * scale;
    this.drawText(
      `Span C: ${lengthCU}"`,
      labelC_X,
      labelC_Y,
      "center",
      "middle",
      0,
      9 * scale
    );

    this.drawPointsAroundLine(points);
  }
}

class TopAndFrontSharedDrawer extends BaseCanvas {
  constructor(canvasId) {
    super(canvasId);
    this.panelHWFactor = 0.4;
  }

  // side glass panels spanScaleLabel
  get spanScaleLabel() {
    return this.scale * (this.spanLabelScaleFactor || 1.2);
  }

  // inital configuration to draw side glass panels
  get config() {
    const { length, panels, panelSize } = this.panelDimensions;

    const gap = 1;

    const panelWidth = panelSize * panels / panels; 

    return {
      panelWidth,
      panelSize,
      panelHeight: 34.25,
      fullHeight: 36.25,
      bottomMountHeight: 2,
      postWidth: 1.6,
      gap,
      rightOffset: 0.75,
      bottomMargin: 2,
      leftOffset: 1,
      heightsArray: [ 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 4, 3.5, 3, 2, 1.5, 1, 0.5, 0, 0, 0.5, 1, 0.5, 1, 1.5, 2.5, 3, 2.5, 2, 1.5, 2, 2.5, 3, 3.5, 3.8, 4, 4.5, 4, 3.5, 3,2.5, 2, 1.5, 1 ]
    };
  }

  // side view panels angle
  getPanelRotationAngle(spanKey) {
    if (!this.isDetailView) return 0;
  
    const shape = this.selectedShape;
  
    const angles = {
      l_shape: { A: 0, B: -Math.PI / 2 },
      u_shape: { A: 0, B: -Math.PI / 2, C: Math.PI },
    };
  
    return angles[shape]?.[spanKey] ?? 0;
  }

  // side glass panels getSpanIndex
  getSpanIndex(spanKey) {
    const shape = this.selectedShape;
    if (shape === "inline") return 0;
    if (shape === "l_shape") return { A: 0, B: 1 }[spanKey];
    if (shape === "u_shape") return { A: 0, B: 1, C: 2 }[spanKey];
    return 0;
  }

  // side glass panels fn
  getTotalSpanCount() {
    const shape = this.selectedShape;
    if (shape === "inline") return 1;
    if (shape === "l_shape") return 2;
    if (shape === "u_shape") return 3;
    return 1;
  }

  // side glass panels fn
  updateScales() {
    this.scale = this.getDynamicScale();
  }

  // side glass panels fn
  sideViewRender() {
    const { length, panels, startIndex } = this.panelDimensions;
    this.length = length;
    this.panels = panels;
    
    const basePosition = this.getSideViewPosition();

    this.draw(
        length,
        panels,
        this.activeSpanKey,
        startIndex,
        basePosition
      );
  }

  // side glass panels draw fn
  draw(length, panels, spanKey, startIndex, basePosition) {
    this._overrideSpanKey = spanKey;
    if (!this.isDetailView) {
      this.drawGrid();
    }
    
    if (!this.isDragging && !this.isZooming) {
      this.drawTopHinges(panels, spanKey, basePosition);
      this.drawBottomHinges(panels, spanKey, basePosition);
    }

    this.drawPanels(panels, spanKey, startIndex, basePosition);

    this.drawHatchBase(panels, spanKey, basePosition);
    
    if (!this.isDetailView) {
      this.drawSpanLabel(
        length,
        panels,
        spanKey,
        basePosition
      );
    }

    const spanIndex = this.getSpanIndex(spanKey);
    const totalSpans = this.getTotalSpanCount();

    this.drawHorizontalDimensions(
      panels,
      spanKey,
      spanIndex,
      totalSpans,
      basePosition
    );
    this.drawVerticalDimensions(basePosition, spanKey);
    delete this._overrideSpanKey; 
  }

  shouldDrawLeftward(spanKey) {
    if (!this.isDetailView) return false;
  
    return (
      (this.selectedShape === "l_shape" && spanKey === "A") || 
      (this.selectedShape === "u_shape" && spanKey === "A") 
    );
  }

  // side glass panels fn
  drawRect(x, y, w, h, color, stroke = true) {
    this.ctx.beginPath();
    this.ctx.fillStyle = color;
    this.ctx.fillRect(x, y, w, h);
    if (stroke) this.ctx.strokeRect(x, y, w, h);
  }

  // side glass panels fn
  drawPanels(panels, spanKey, startIndex = 0, basePosition) {
    const { panelWidth, gap, leftOffset, panelHeight, bottomMargin } = this.config;
    const angle = this.getPanelRotationAngle(spanKey);
    const drawToLeft = this.shouldDrawLeftward(spanKey);
    const isVertical = Math.abs(angle) === Math.PI / 2;
    
    const base = this.getTransformedBase(spanKey, basePosition);
    const baseX = base.x;
    const baseY = base.y + this.panelScale * bottomMargin;
    
    let ctx = this.ctx;

    if(this.isDragging) {
      ctx.imageSmoothingEnabled = false;
    }
    ctx.save();
    ctx.translate(baseX, baseY);
    if (angle) ctx.rotate(angle);
  
    // === Batch fill and stroke for all panels ===
    ctx.fillStyle = this.glassShade;
    ctx.strokeStyle = this.grayColor;
    ctx.beginPath();
  
    const drawIndex = (i) => (isVertical ? panels - i - 1 : i);
    const rects = [];
    
    const isInclusive = (
      spanKey === 'A' &&
      (this.selectedShape === 'l_shape' || this.selectedShape === 'u_shape') && 
      this.isDetailView
    );
    
    const start = isInclusive ? 1 : 0;
    const end = isInclusive ? panels + 1 : panels;
    
    for (let i = start; i < end; i++) {
      const actualIndex = drawIndex(i);
      const x = this.panelScale * (leftOffset + (drawToLeft ? -1 : 1) * actualIndex * (panelWidth + gap) );
      const y = 0;
      const w = panelWidth * this.panelScale;
      const h = panelHeight * this.panelScale;
  
      ctx.rect(x, y, w, h);
  
      // Store for labeling
      rects.push({ x, y, w, h, label: `Panel ${startIndex + actualIndex + 1}` });
    }

    ctx.fill();
    ctx.stroke();
    ctx.restore();
    
    
    // === Separate loop for text labels ===
    ctx.save();
    ctx.translate(baseX, baseY);
    if (angle) ctx.rotate(angle);
  
    rects.forEach(({ x, y, w, h, label }) => {
      this.drawPanelLabel(label, x, y, w, h);
    });
  
    ctx.restore();
  }

  // drawPanels helper function - side view fn
  drawSinglePanel(index, x, y, w, h, label) {
    this.drawRect(x, y, w, h, this.glassShade);
    this.drawPanelLabel(label, x, y, w, h);
  }

  // drawPanels helper function - side view fn
  getTransformedBase(spanKey, basePosition) {
    const { scale, gridOffset } = this;
  
    // If basePosition is passed, use it fully and skip all overrides
    if(this.activeView == 'side') {
      const basePosition = this.getSideViewPosition();
        return {
          x: basePosition.x * scale + this.gridOffset.x,
          y: basePosition.y * scale + this.gridOffset.y,
        };
    } else if (this.activeView == 'detail' && basePosition) {
      return {
        x: basePosition.x * scale,
        y: basePosition.y * scale,
      };
    } 

    return { x : 0, y : 0 };
  }


  // to draw diagonally aligned random lined base - side glass panels fn
  drawHatchBase(panels, spanKey, basePosition) {
    const {
      panelWidth,
      gap,
      leftOffset,
      panelHeight,
      heightsArray,
      bottomMargin,
      bottomMountHeight,
    } = this.config;
  
    const angle = this.getPanelRotationAngle(spanKey);
    const isVertical = Math.abs(angle) === Math.PI / 2;
    const drawToLeft = this.shouldDrawLeftward(spanKey);
  
    // Get base position with scale + gridOffset
    const { x: baseXRaw, y: baseYRaw } = this.getTransformedBase(spanKey, basePosition);
  
    let baseX = baseXRaw;
    let baseY = baseYRaw;
  
    if (!isVertical) {
      baseX += this.panelScale * leftOffset;
  
      if (drawToLeft) {
        baseX -= this.panelScale * (panelWidth * panels + gap * (panels - 1));
      }
  
      const isSpanC = this.selectedShape === "u_shape" && spanKey === "C";
  
      if (isSpanC && this.isDetailView) {
        baseY -= this.panelScale * (panelHeight + bottomMargin);
      } else {
        baseY += this.panelScale * (panelHeight + bottomMargin) + 4 * this.panelScale;
      }
    } else {
      // Vertical: offset to right of panel stack
      const panelRowLength = this.panelScale * 38;
      baseX += panelRowLength;
      baseY += this.panelScale * leftOffset;
    }
  
    // Align width and height to panel dimensions
    const w = this.panelScale * (panelWidth * panels + gap * (panels - 1));
    const h = 10 * this.panelScale; 
  
    this.ctx.save();
    this.ctx.translate(baseX, baseY);
    if (angle) this.ctx.rotate(angle);
  
    this.drawDiagonalHatchRect(w, h, heightsArray);
  
    // Draw top base line
    this.ctx.beginPath();
    this.ctx.moveTo(0, 0);
    this.ctx.lineTo(w, 0);
    this.ctx.lineWidth = 1;
    this.ctx.strokeStyle = this.grayColor;
    this.ctx.stroke();
  
    this.ctx.restore();
  }

  // drawHatchBase helper function - side view fn
  drawDiagonalHatchRect(w, h, heightsArray) {
    this.ctx.save();
    this.ctx.beginPath();
    this.ctx.rect(0, 0, w, h);
    this.ctx.clip();
  
    this.ctx.strokeStyle = this.grayColor;
    this.ctx.lineWidth = 0.7;
  
    const spacing = 1.5 * this.panelScale; 
    for (let x = 0, i = 0; x < w; x += spacing, i++) {
      const hVal = heightsArray[i % heightsArray.length] * this.panelScale;
      this.ctx.beginPath();
      this.ctx.moveTo(x, 0);
      this.ctx.lineTo(x + hVal, hVal);
      this.ctx.stroke();
    }
  
    this.ctx.restore();
  }

  drawSpanLabel(length, panels, spanKey, basePosition) {
    const { panelWidth, gap, leftOffset, panelHeight, bottomMargin } =
      this.config;
    const angle = this.getPanelRotationAngle(spanKey);
    const isVertical = Math.abs(angle) === Math.PI / 2;

    const { x: baseXRaw, y: baseYRaw } = this.getTransformedBase(
      spanKey,
      basePosition
    );

    const spanLength = panelWidth * panels + gap * (panels - 1);
    const spanWidthPx = this.panelScale * spanLength;

    if (!isVertical) {
      // Horizontal: label centered below span
      const xStart = baseXRaw + this.panelScale * leftOffset;
      const centerX = xStart + spanWidthPx / 2;
      const labelY =
        baseYRaw + this.panelScale * (panelHeight + bottomMargin + 14);

      this.drawText(
        `Span ${spanKey} ${length}"`,
        centerX,
        labelY,
        "center",
        "middle",
        0,
        3 * this.panelScale
      );
    } else {
      // Vertical: label centered to the left of vertical span (bottom to top)
      const centerY = baseYRaw + this.panelScale * leftOffset + spanWidthPx / 2;
      const labelX =
        baseXRaw - this.panelScale * (panelHeight + bottomMargin + 14);

      this.drawText(
        `Span ${spanKey} ${length}"`,
        labelX,
        centerY,
        "center",
        "middle",
        -Math.PI / 2,
        3 * this.panelScale
      );
    }
  }

  // side glass panels fn
  drawHorizontalDimensions(
  panels,
  spanKey,
  spanIndex = 0,
  totalSpans = 1,
  basePosition
) {
    const { panelWidth, panelSize, gap } = this.config;
    const {
      x: originX,
      y: originY,
      angle,
    } = this.getSpanDimensionOrigin(spanKey, basePosition);
    const isVertical = Math.abs(angle) === -Math.PI / 2;
  
    const drawToLeft = this.shouldDrawLeftward(spanKey);
  
    const isFirstSpan = spanIndex === 0;
    const isLastSpan = spanIndex === totalSpans - 1;
    const leftOuterGap = isFirstSpan ? 1.0 : 0.75;
    const rightOuterGap = isLastSpan ? 1.0 : 0.75;
  
    const tick = 3 * this.panelScale;
    const lineOffset = 2 * this.panelScale;
    const fontOffset = 4 * this.panelScale;
  
    this.ctx.save();
    const margin = angle === -Math.PI / 2 ? this.panelScale * 6 : 0;
    this.ctx.translate(originX, originY + margin);
    if (angle) this.ctx.rotate(angle);
  
    let x = 0;
    let y = isVertical ? 0 : -4 * this.panelScale;
  
    const drawDimension = (x1, x2, label) => {
      const cx = (x1 + x2) / 2;
      const rotation = isVertical ? -Math.PI / 2 : 0;
      if (!this.isDragging && !this.isZooming) {
        this.drawText(
          label,
          cx,
          y - fontOffset,
          "center",
          "middle",
          rotation,
          2.5 * this.panelScale
        );
        this.drawLineWithTicks(x1, x2, y - lineOffset, tick, isVertical, true);
      }
    };
  
    const drawDimensionBlock = (direction = 1) => {
      // Left outer gap
      let x1 = 0;
      let x2 = x1 + direction * leftOuterGap * this.panelScale;
      drawDimension(x1, x2, `${leftOuterGap.toFixed(2)}"`);
      x1 = x2;
  
      for (let i = 0; i < panels; i++) {
        x2 = x1 + direction * panelWidth * this.panelScale;
        drawDimension(x1, x2, `${panelSize.toFixed(3)}"`);
        x1 = x2;
  
        if (i < panels - 1) {
          x2 = x1 + direction * gap * this.panelScale;
          drawDimension(x1, x2, `${gap.toFixed(2)}"`);
          x1 = x2;
        }
      }
  
      // Right outer gap
      x2 = x1 + direction * rightOuterGap * this.panelScale;
      drawDimension(x1, x2, `${rightOuterGap.toFixed(2)}"`);
    };
  
    drawDimensionBlock(drawToLeft ? -1 : 1);
  
    this.ctx.restore();
  }

  // drawhorizontalDimensions helper fn
  getSpanDimensionOrigin(spanKey, basePosition) {
    const { scale, panelScale } = this;
    const { x: baseX, y: baseY } = this.getTransformedBase(
      spanKey,
      basePosition
    );
    const isDetail = this.isDetailView;
    const shape = this.selectedShape;

    let offsetX = panelScale * this.config.leftOffset - panelScale;
    let offsetY = 0;

    if (isDetail && shape === "l_shape" && spanKey === "B") {
      offsetX = panelScale * this.config.leftOffset - 2.75 * panelScale;
      offsetY = -4 * panelScale;
    }

    return {
      x: baseX + offsetX,
      y: baseY + offsetY,
      angle: this.getPanelRotationAngle(spanKey),
    };
  }

  // top horizontal line inverted double ticks - side glass panels fn
  drawLineWithTicks(
    x1,
    x2,
    anchor,
    tickHeight,
    isVertical = false,
    flip = false,
    inward = false
  ) {
    this.ctx.beginPath();

    if (isVertical) {
      this.ctx.moveTo(anchor, x1);
      this.ctx.lineTo(anchor, x2);

      [x1, x2].forEach((y) => {
        const tickX = inward
          ? anchor - tickHeight
          : flip
          ? anchor + tickHeight
          : anchor - tickHeight;
        this.ctx.moveTo(anchor, y);
        this.ctx.lineTo(tickX, y);
      });
    } else {
      this.ctx.moveTo(x1, anchor);
      this.ctx.lineTo(x2, anchor);

      [x1, x2].forEach((x) => {
        let tickY;
        if (inward) {
          tickY = anchor - tickHeight; // << Ticks point upward (inward)
        } else {
          tickY = flip ? anchor + tickHeight : anchor - tickHeight;
        }
        this.ctx.moveTo(x, anchor);
        this.ctx.lineTo(x, tickY);
      });
    }

    this.ctx.strokeStyle = this.grayColor;
    this.ctx.stroke();
  }

  // to draw upper hinges between panels - side glass panels fn
  drawTopHinges(panels, spanKey, basePosition) {
    const { panelWidth, gap, leftOffset, bottomMargin } = this.config;
    const px = this.panelScale;
    const drawToLeft = this.shouldDrawLeftward(spanKey);
    const isSpanC = this.selectedShape === "u_shape" && spanKey === "C";
    const { x: baseX, y: baseY } = this.getTransformedBase(spanKey, basePosition);
    const isVertical = this.getPanelRotationAngle(spanKey) === -Math.PI / 2;
  
    for (let i = 0; i < panels - 1; i++) {
      const idx = drawToLeft ? panels - 2 - i : i;
      const offset = px * (leftOffset + idx * (panelWidth + gap));
      const w = 5 * px, h = 1.5 * px;
      let x, y;
  
      if (!isVertical) {
        if (isSpanC && this.isDetailView) {
          x = baseX - offset - px * panelWidth + w - 8 * px;
          y = baseY - px * (bottomMargin + 2 * px);
        } else if (drawToLeft) {
          x = baseX - offset - px * panelWidth + w - 7 * px;
          y = baseY + px * bottomMargin + 2 * px;
        } else {
          x = baseX + offset + px * panelWidth - w + 3 * px;
          y = baseY + px * bottomMargin + 2 * px;
        }
      } else {
        const yOffset = offset + 1.045 * px * panelWidth - h;
        x = baseX + px * bottomMargin + 2 * px;
        y = baseY - yOffset;
      }
  
      this.drawRect(x, y, isVertical ? h : w, isVertical ? w : h, this.grayColor, false);
    }
  }

  // to draw bottom corner side hinges panels - side glass panels fn
  drawBottomHinges(panels, spanKey, basePosition) {
    const {
      panelWidth,
      gap,
      leftOffset,
      postWidth,
      panelHeight,
      bottomMountHeight,
      bottomMargin,
    } = this.config;
  
    const px = this.panelScale;
    const isVertical = this.getPanelRotationAngle(spanKey) === -Math.PI / 2;
    const drawToLeft = this.shouldDrawLeftward(spanKey);
    const isSpanC = this.selectedShape === "u_shape" && spanKey === "C";
  
    const { x: baseX, y: baseY } = this.getTransformedBase(spanKey, basePosition);
  
    const mountOffset = 6 * px;
    const postW = postWidth * px;
    const mountH = bottomMountHeight * px + 2 * px;
  
    const loop = [...Array(panels).keys()].map(i => drawToLeft ? panels - 1 - i : i);
  
    loop.forEach((i) => {
      const offset = px * (leftOffset + i * (panelWidth + gap));
  
       if (!isVertical) {
          const isRTL = drawToLeft || (isSpanC && this.isDetailView);
          const panelStartX = isRTL ? baseX - offset - px * panelWidth : baseX + offset;
        
          let y;
          if (isSpanC && this.isDetailView) {
            y = baseY - px * (panelHeight + bottomMargin);
          } else {
            y = baseY + px * (panelHeight + bottomMargin);
          }
        
          const leftMountX = panelStartX + mountOffset;
          const rightMountX = panelStartX + px * panelWidth - mountOffset;
        
          [leftMountX, rightMountX].forEach(x =>
            this.drawRect(x - postW / 2, y, postW, mountH, this.grayColor, false)
          );
       } else {
        const y = baseY - offset;
        const x = baseX + px * (panelHeight + bottomMargin) - 2 * px;
  
        const leftMountY = y - (px * panelWidth - mountOffset);
        const rightMountY = y - mountOffset;
  
        [leftMountY, rightMountY].forEach(yCenter =>
          this.drawRect(x, yCenter - postW / 2, mountH, postW, this.grayColor, false)
        );
      }
    });
  }


  // to print height vertically on the left of panel shape - side glass panels fn
  drawVerticalDimensions(basePosition, spanKey) {
    const { panelHeight, leftOffset, panelWidth, gap } = this.config;
    const height = this.selectedRailingHeight;
    const angle = this.getPanelRotationAngle(spanKey); 
    const isVertical = angle === -Math.PI / 2;
  
    const { x: baseX, y: baseY } = this.getTransformedBase(spanKey, basePosition);
  
    const px = this.panelScale;
    const tick = 2 * px;
    const labelSize = 4 * px;
    const offset = 3 * px;
  
    if (isVertical) {
      const startX = baseX + px * leftOffset - 1 * px;
      const endX = startX + px * panelHeight;
      const y = baseY + 5 * px;
  
      this.drawLineWithTicks(startX, endX, y, tick, false, false);
      this.drawText(`${height}"`, (startX + endX) / 2, y + offset, "center", "middle", 0, labelSize);
    } else {
      const isSpanC = this.selectedShape === "u_shape" && spanKey === "C";
      const isSpanA = ["l_shape", "u_shape"].includes(this.selectedShape) &&
                spanKey === "A" &&
                this.isDetailView;
  
      if (isSpanC && this.isDetailView) {
        const x = baseX + 2.5 * px;
        const startY = baseY + 2 * px;
        const endY = startY - px * panelHeight;
        this.drawLineWithTicks(startY, endY, x, tick, true, false, true);
        this.drawText(`${height}"`, x + offset, (startY + endY) / 2, "center", "middle", -Math.PI / 2, labelSize);
      }else if (isSpanA) {
        const { panels } = this.panelDimensions;
        const totalWidth = px * (panelWidth * panels + gap * (panels - 1));
        const x = baseX + 5 * px;
        const startY = baseY + 2 * px;
        const endY = startY + px * panelHeight;
        this.drawLineWithTicks(startY, endY, x, tick, true, false, false);
        this.drawText(`${height}"`, x + offset, (startY + endY) / 2, "center", "middle", -Math.PI / 2, labelSize);
      } else {
        // Default case
        const x = baseX - 5 * px;
        const startY = baseY + 2 * px;
        const endY = startY + px * panelHeight;
        this.drawLineWithTicks(startY, endY, x, tick, true, true, false); 
        this.drawText(`${height}"`, x - offset, (startY + endY) / 2, "center", "middle", -Math.PI / 2, labelSize);
      }
    }
  }


  // to print label center of panel - side glass panels fn
  drawPanelLabel(label, x, y, w, h) {
    const centerX = x + w / 2;
    const centerY = y + h / 2;
    this.drawText(
      label,
      centerX,
      centerY,
      "center",
      "middle",
      0,
      4 * this.panelScale
    );
  }

  // Dynamic localScale based on shape and max span length - top view fn
  get getSpanScale() {
    if (!this.shapeInputs) return 1;

    const shape = this.selectedShape;
    const inputs = this.shapeInputs;

    let maxLength = 0;
    if (shape === "inline") [maxLength] = inputs;
    else if (shape === "l_shape") maxLength = Math.max(inputs[0], inputs[1]);
    else if (shape === "u_shape")
      maxLength = Math.max(inputs[0], inputs[1], inputs[2]);

    const shapeFitScale = this.getSpanScaleFactor(maxLength);
    return shapeFitScale * this.scale;
  }

  // top view fn
  topViewRender() {
    this.drawTopViewShape();
  }

  // top view fn
  drawTopViewShape() {
    const inputs = this.shapeInputs;
    if (!inputs) return;

    if (!this.isDetailView) {
      this.drawGrid();
    }

    if (this.selectedShape === "inline") {
      const [lengthA, panelsA] = inputs;
      this.drawTopInlineShape(lengthA, panelsA);
    } else if (this.selectedShape === "l_shape") {
      const [lengthAL, lengthBL, panelsAL, panelsBL] = inputs;
      this.drawTopLShape(lengthAL, lengthBL, panelsAL, panelsBL);
    } else if (this.selectedShape === "u_shape") {
      const [lengthAU, lengthBU, lengthCU, panelsAU, panelsBU, panelsCU] =
        inputs;
      this.drawTopUShape(
        lengthAU,
        lengthBU,
        lengthCU,
        panelsAU,
        panelsBU,
        panelsCU
      );
    }
  }

  // top view fn
  drawTopInlineShape(lengthA, panelsA, baseOffsetY) {
    const { gridOffset } = this;
    const { panelWidth } = this.panelDimensions;
    const scale = this.getSpanScale;

    const basePosition = this.getDetailViewBP("inline");

    const baseX = basePosition.x * this.scale + gridOffset.x;
    let baseY = basePosition.y * this.scale + gridOffset.y;

    const spanScaleFactor = this.getSpanScaleFactor(lengthA);

    const adjustedLengthA = lengthA * this.panelScale;
    
    let startX = baseX;
    let endX = baseX + adjustedLengthA;
    const centerX = (startX + endX) / 2;

    const points = [
      { x: startX, y: baseY },
      { x: endX, y: baseY },
    ];

    const topPanelPoints = [
      { x: startX, y: baseY - 5 * scale },
      { x: endX, y: baseY - 5 * scale },
    ];

    this.drawSpanLine(startX, endX, baseY);

    if (!this.isDetailView) {
      this.drawPanelSizeLabels(points, panelWidth, panelsA);
      // dark shade panels
      this.drawSpanWithPanels(topPanelPoints, panelsA, {
        strokeStyle: this.lightGray,
        fillStyle: this.grayColor,
        borderWidth: this.inverseScale * 0.4,
        cornerRadius: 0,
        panelHWFactor: 1.6 * scale,
      });
    }

    if (!this.isDragging && !this.isZooming) {
      this.drawDualHingesPerPanel(points, topPanelPoints, panelsA, lengthA);
    }

    // glass panels
    this.drawSpanWithPanels(points, panelsA, {
      strokeStyle: this.blackColor,
      fillStyle: this.glassShade,
      borderWidth: this.inverseColor * 0.02,
      cornerRadius: 1,
      panelHWFactor: 0.3 * scale,
    });

    this.drawPointsAroundLine(points);
    this.drawText(
      `Span A ${lengthA}"`,
      centerX,
      baseY + 8 * scale,
      "center",
      "middle",
      0,
      3.5 * scale
    );

    // detail view glass panels Shape
    if(!this.isDetailView) return;
    this.activeSpanKey = "A";
    this.draw(lengthA, panelsA, "A", 0, { x: (baseX) / this.scale, y: (baseY + 23 * this.panelScale) / this.scale });
  }

  // top view fn
  drawTopLShape(lengthAL, lengthBL, panelsAL, panelsBL) {
    const scale = this.getSpanScale;
    const px = this.scale;
    const { gridOffset } = this;
    const basePosition = this.getDetailViewBP("l_shape");

    let baseX = basePosition.x * px + gridOffset.x;
    let baseY = basePosition.y * px + gridOffset.y;

    let adjA = lengthAL * this.panelScale;
    let adjB = lengthBL * this.panelScale;

    if (this.isDetailView) {
      baseY -= 60 * px;
    }

    const A = { x: baseX - adjA, y: baseY };
    const B = { x: baseX, y: baseY };
    const C = { x: baseX, y: baseY - adjB };

    const spanA = [A, B],
      spanB = [B, C];
    const topOffset = 5 * scale;
    const fontSize = 2.5 * scale;

    const topSpan = {
      A: spanA.map((p) => ({ x: p.x, y: p.y - topOffset })),
      B: spanB.map((p) => ({ x: p.x - topOffset, y: p.y })),
    };

    const hingeSpan = {
      A: spanA.map((p) => ({ x: p.x, y: p.y - topOffset })),
      B: spanB.map((p) => ({ x: p.x - topOffset, y: p.y })),
    };

    // Span lines
    this.drawSpanLine(A.x, B.x, A.y);
    this.drawSpanLine(B.y, C.y, B.x, true);

    // Top bars (only in normal mode)
    if (!this.isDetailView) {
      this.drawSpanWithPanels(topSpan.A, panelsAL, {
        strokeStyle: this.lightGray,
        fillStyle: this.grayColor,
        borderWidth: this.inverseScale * 0.4,
        cornerRadius: 0,
        panelHWFactor: 1.6 * scale,
        trimLastPanel: true,
        trimAmount: 4 * scale,
      });

      this.drawSpanWithPanels(topSpan.B, panelsBL, {
        strokeStyle: this.lightGray,
        fillStyle: this.grayColor,
        borderWidth: this.inverseScale * 0.4,
        cornerRadius: 0,
        panelHWFactor: 1.6 * scale,
        trimFirstPanel: true,
        trimAmount: 3.5 * scale,
      });
    }

    const maxLength = this.getMaxSpanLength(lengthAL, lengthBL);

    // Hinges
    if (!this.isDragging && !this.isZooming) {
      this.activeSpanKey = "A";
      this.drawDualHingesPerPanel(spanA, hingeSpan.A, panelsAL, maxLength);

      this.activeSpanKey = "B";
      this.drawDualHingesPerPanel(spanB, hingeSpan.B, panelsBL, maxLength, 'B');
    }

    // Glass Panels
    [
      ["A", spanA, panelsAL],
      ["B", spanB, panelsBL],
    ].forEach(([key, span, count]) => {
      this.drawSpanWithPanels(span, count, {
        strokeStyle: this.blackColor,
        fillStyle: this.glassShade,
        borderWidth: this.inverseColor * 0.02,
        cornerRadius: 1,
        panelHWFactor: 0.3 * scale,
      });

      this.activeSpanKey = key;
      this.drawPanelSizeLabels(span, this.panelDimensions.panelWidth, count);
    });
    
    // Labels
    this.drawText(`Span A ${lengthAL}"`, (A.x + B.x) / 2, A.y + 7 * scale, "center", "middle", 0, fontSize);
    this.drawText(`Span B ${lengthBL}"`, B.x + 7 * scale, (B.y + C.y) / 2, "center", "middle", -Math.PI / 2, fontSize);
    
    this.drawPointsAroundLine([A, B, C]);
  
    // detail view glass panels Shape
    if (!this.isDetailView) return;
 
    // Use getTransformedBase for both spans
    this.activeSpanKey = 'A';
    this.draw(lengthAL, panelsAL, "A", 0, { x: B.x / this.scale, y:( B.y + 35 * this.panelScale) / this.scale });
    
    this.activeSpanKey = 'B';
    this.draw(lengthBL, panelsBL, "B", panelsAL, { x: (B.x + 35 * this.panelScale) / this.scale, y: B.y / this.scale });
  }

  // top view fn
  drawTopUShape(lengthAU, lengthBU, lengthCU, panelsAU, panelsBU, panelsCU) {
    const scale = this.getSpanScale;
    const px = this.scale;
    const { gridOffset } = this;
    
    const detailBase = this.getDetailViewBP("u_shape");
    let baseX = detailBase.x * px + gridOffset.x;
    let baseY = detailBase.y * px + gridOffset.y;

    let adjA = lengthAU * this.panelScale;
    let adjB = lengthBU * this.panelScale;
    let adjC = lengthCU * this.panelScale;

    if (this.isDetailView) {
      baseY -= 50 * px;
    }

    const A = { x: baseX - adjA, y: baseY };
    const B = { x: baseX, y: baseY };
    const C = { x: baseX, y: baseY - adjB };
    const D = { x: baseX - adjC, y: baseY - adjB };
 
    const spanA = [A, B], spanB = [B, C], spanC = [C, D];
    const topOffset = 5 * scale;
    const fontSize = 2.5 * scale;

    const topSpan = {
      A: spanA.map((p) => ({ x: p.x, y: p.y - topOffset })),
      B: spanB.map((p) => ({ x: p.x - topOffset, y: p.y })),
      C: spanC.map((p) => ({ x: p.x, y: p.y + topOffset })),
    };

    const hingeSpanC = spanC.map((p) => ({
      x: p.x,
      y: p.y + topOffset + 1.6 * scale,
    }));

    // Span lines
    this.drawSpanLine(A.x, B.x, A.y);
    this.drawSpanLine(B.y, C.y, B.x, true);
    this.drawSpanLine(C.x, D.x, D.y, false, "up");

    // Span labels
    this.drawText(`Span A ${lengthAU}"`, (A.x + B.x) / 2, A.y + 6 * scale, "center", "middle", 0, fontSize);
    this.drawText(`Span B ${lengthBU}"`, B.x + 6 * scale, (B.y + C.y) / 2, "center", "middle", -Math.PI / 2, fontSize);
    this.drawText(`Span C ${lengthCU}"`, (C.x + D.x) / 2, D.y - 6 * scale, "center", "middle", 0, fontSize);

    // Top bars
    if (!this.isDetailView) {
      this.drawSpanWithPanels(topSpan.A, panelsAU, {
        strokeStyle: this.lightGray,
        fillStyle: this.grayColor,
        borderWidth: this.inverseScale * 0.4,
        cornerRadius: 0,
        panelHWFactor: 1.6 * scale,
        trimLastPanel: true,
        trimAmount: 3.5 * scale,
      });

      this.drawSpanWithPanels(topSpan.B, panelsBU, {
        strokeStyle: this.lightGray,
        fillStyle: this.grayColor,
        borderWidth: this.inverseScale * 0.4,
        cornerRadius: 0,
        panelHWFactor: 1.6 * scale,
        trimFirstPanel: true,
        trimLastPanel: true,
        trimAmount: 5 * scale,
      });

      this.drawSpanWithPanels(topSpan.C, panelsCU, {
        strokeStyle: this.lightGray,
        fillStyle: this.grayColor,
        borderWidth: this.inverseScale * 0.4,
        cornerRadius: 0,
        panelHWFactor: 1.6 * scale,
        trimFirstPanel: true,
        trimAmount: 4 * scale,
      });
    }

    const maxLength = this.getMaxSpanLength(lengthAU, lengthBU, lengthCU);

    // Hinges
    if (!this.isDragging && !this.isZooming) {
      this.activeSpanKey = "A";
      this.drawDualHingesPerPanel(spanA, topSpan.A, panelsAU, maxLength);
      
      this.activeSpanKey = "B";
      this.drawDualHingesPerPanel(spanB, topSpan.B, panelsBU, maxLength, 'B');
      
      this.activeSpanKey = "C";
      this.drawDualHingesPerPanel(spanC, hingeSpanC, panelsCU, maxLength);
    }

    // Glass panels
    [
      ["A", spanA, panelsAU],
      ["B", spanB, panelsBU],
      ["C", spanC, panelsCU],
    ].forEach(([key, span, count]) => {
      this.drawSpanWithPanels(span, count, {
        strokeStyle: this.blackColor,
        fillStyle: this.glassShade,
        borderWidth: this.inverseColor * 0.02,
        cornerRadius: 1,
        panelHWFactor: 0.3 * scale,
      });
      
      this.activeSpanKey = key;
      this.drawPanelSizeLabels(
        span,
        this.panelDimensions.panelWidth,
        count,
        key !== "C"
      );
    });

    // Corner indicators
    this.drawPointsAroundLine([A, B, C, D]);

    // detail view glass panels Shape
    if (!this.isDetailView) return;
  
    this.activeSpanKey = 'A';
    this.draw(lengthAU, panelsAU, "A", 0, {
      x: (B.x) / px,
      y: (B.y + 30 * this.panelScale) / px,
    });
    
    this.activeSpanKey = 'B';
    this.draw(lengthBU, panelsBU, "B", panelsAU, {
      x: (B.x + 30 * this.panelScale) / px,
      y: (B.y) / px,
    });
    
    this.activeSpanKey = 'C';
    this.draw(lengthCU, panelsCU, "C", panelsAU + panelsBU, {
      x: (C.x) / px,
      y: (C.y - 30 * this.panelScale) / px,
    });

  }

  // top view fn
  drawPanelSizeLabels(points, panelWidth, panels, rotate = true) {
    const ctx = this.ctx;
    const scale = this.getSpanScale;
    const gap = 3 * scale;
    const offsetDistance = 1.8 * scale;
    const { panelSize } = this.config;

    const {
      ux,
      uy,
      perpX,
      perpY,
      angle,
      length: len,
    } = this.getLineDirectionData(points[0], points[1]);
    if (len === 0) return;

    const usableLength = len - gap * (panels - 1);
    const panelLength = usableLength / panels;

    for (let i = 0; i < panels; i++) {
      const distanceAlongLine = i * (panelLength + gap) + panelLength / 2;

      const labelX =
        points[0].x + ux * distanceAlongLine + perpX * offsetDistance;
      const labelY =
        points[0].y + uy * distanceAlongLine + perpY * offsetDistance;

      const label = `${panelSize.toFixed(2)}"`;
      this.drawText(
        label,
        labelX,
        labelY,
        "center",
        "middle",
        rotate ? angle : 0,
        1.4 * scale
      );
    }
  }

  // top view fn
  drawDualHingesPerPanel(basePoints, topPoints, panels, length, activeSpanKey) {
    const ctx = this.ctx;
    const factorScale = this.getSpanScaleFactor(length);
    let scale = factorScale * this.scale;

    if(this.activeView == 'top' || this.activeView == 'detail') 
    {
      scale = factorScale * this.scale * 0.5;
    }
    
    const gap = (1 / panels) * scale;
  
    const hingeWidth = 1 * scale;
    const strokeWidth = 0.06 * scale;
    const shaftSize = 1.5 * scale;
    const plateSize = 6 * scale;
    const color = this.grayColor;
    const borderColor = this.borderColor;
    let hingeInset = 8 * scale;
  
    const baseDir = this.getLineDirectionData(basePoints[0], basePoints[1]);
    const topDir = this.getLineDirectionData(topPoints[0], topPoints[1]);
    const isVertical = Math.abs(baseDir.uy) > Math.abs(baseDir.ux);
    const shaftOrientation = isVertical ? "vertical" : "horizontal";

    if (baseDir.length === 0 || topDir.length === 0) return;

    const totalGap = gap * (panels - 1);
    const usableLength = baseDir.length - totalGap;
    const panelLength = usableLength / panels;

    for (let i = 0; i < panels; i++) {
      const baseDistance = i * (panelLength + gap);

      const panelStart = {
        x: basePoints[0].x + baseDir.ux * baseDistance,
        y: basePoints[0].y + baseDir.uy * baseDistance,
      };

      const left = this.getHingePosition(panelStart, baseDir, hingeInset);
      const right = this.getHingePosition(
        panelStart,
        baseDir,
        panelLength - hingeInset
      );

      [left, right].forEach((p) => {
        const offset = Math.hypot(p.x - basePoints[0].x, p.y - basePoints[0].y);
        const top = {
          x: topPoints[0].x + topDir.ux * offset,
          y: topPoints[0].y + topDir.uy * offset,
        };
        this.drawBottomPlate(p, plateSize, color, borderColor, strokeWidth);
        if (!this.isDetailView) {
          this.drawHingeShaft(
            p,
            top,
            hingeWidth,
            strokeWidth,
            color,
            borderColor
          );
        }
        this.drawBottomShaft(
          p,
          shaftSize,
          color,
          borderColor,
          strokeWidth,
          shaftOrientation
        );
      });
    }
  }

  // top view fn
  getHingePosition(origin, direction, distance) {
    return {
      x: origin.x + direction.ux * distance,
      y: origin.y + direction.uy * distance,
    };
  }

  // connecting hinge - top view fn
  drawHingeShaft(
    start,
    end,
    width,
    strokeWidth,
    fillColor,
    borderColor,
    maxLengthFraction = 0.7
  ) {
    const ctx = this.ctx;
    const scale = this.getSpanScale;

    const fullLength = Math.hypot(end.x - start.x, end.y - start.y);
    const shaftLength = fullLength * maxLengthFraction;
    const angle = Math.atan2(end.y - start.y, end.x - start.x);
    const shift = fullLength - shaftLength - 1.6 * scale;

    ctx.save();
    ctx.translate(
      start.x + Math.cos(angle) * shift,
      start.y + Math.sin(angle) * shift
    );
    ctx.rotate(angle);

    ctx.fillStyle = fillColor;
    ctx.fillRect(0, -width / 2, shaftLength, width);

    ctx.strokeStyle = borderColor;
    ctx.lineWidth = strokeWidth;
    ctx.strokeRect(0, -width / 2, shaftLength, width);

    ctx.restore();
  }

  // main plate hinge - top view fn
  drawBottomPlate(p, size, fillColor, borderColor, strokeWidth) {
    const ctx = this.ctx;
    const scale = this.getSpanScale;
    const px = p.x - size / 2;
    const py = p.y - size / 2;

    ctx.fillStyle = fillColor;
    ctx.fillRect(px, py, size, size);

    ctx.strokeStyle = borderColor;
    ctx.lineWidth = strokeWidth;
    ctx.strokeRect(px, py, size, size);
  }

  // triple rectangle hinge section - top view fn
  drawBottomShaft(
    p,
    size,
    fillColor,
    borderColor,
    strokeWidth = 0.06 * this.getSpanScale,
    orientation
  ) {
    const ctx = this.ctx;
    const scale = this.getSpanScale;

    const isHorizontal = orientation === "horizontal";

    const mainWidth = isHorizontal ? size : size * 2.4;
    const mainHeight = isHorizontal ? size * 2.4 : size;

    const mainX = p.x - mainWidth / 2;
    const mainY = p.y - mainHeight / 2;

    ctx.lineWidth = strokeWidth;
    ctx.strokeStyle = borderColor;
    ctx.fillStyle = fillColor;

    // Draw main shaft block
    ctx.fillRect(mainX, mainY, mainWidth, mainHeight);
    ctx.strokeRect(mainX, mainY, mainWidth, mainHeight);

    // Side rectangles
    const sideThickness = 0.5 * scale;
    const sideLength = size * 2;

    const sideW = isHorizontal ? sideThickness : sideLength;
    const sideH = isHorizontal ? sideLength : sideThickness;

    const sideOffset = isHorizontal ? mainWidth / 2 : mainHeight / 2;

    // Center vertically/horizontally with main block
    const sideX1 = isHorizontal ? mainX - sideThickness : p.x - sideLength / 2;
    const sideY1 = isHorizontal ? p.y - sideLength / 2 : mainY - sideThickness;

    const sideX2 = isHorizontal ? mainX + mainWidth : p.x - sideLength / 2;
    const sideY2 = isHorizontal ? p.y - sideLength / 2 : mainY + mainHeight;

    // Draw both side rectangles
    ctx.fillRect(sideX1, sideY1, sideW, sideH);
    ctx.strokeRect(sideX1, sideY1, sideW, sideH);

    ctx.fillRect(sideX2, sideY2, sideW, sideH);
    ctx.strokeRect(sideX2, sideY2, sideW, sideH);
  }

  // top view fn
  drawSpanLine(from, to, anchor, isVertical = false, direction = "down") {
    const ctx = this.ctx;
    const scale = this.getSpanScale;
    const tickLength = 2 * scale;
    const offsetH = 3.5 * scale;
    const offsetV = 3.5 * scale;

    ctx.strokeStyle = this.blackColor;
    ctx.lineWidth = 0.2 * scale;
    ctx.beginPath();

    if (isVertical) {
      const x = anchor + (direction === "left" ? -offsetV : offsetV);

      ctx.moveTo(x - tickLength, from);
      ctx.lineTo(x, from);
      ctx.lineTo(x, to);
      ctx.lineTo(x - tickLength, to);
    } else {
      const y = anchor + (direction === "up" ? -offsetH : offsetH);
      const tickDir = tickLength * (direction === "up" ? 1 : -1);

      ctx.moveTo(from, y);
      ctx.lineTo(from, y + tickDir);
      ctx.moveTo(from, y);
      ctx.lineTo(to, y);
      ctx.moveTo(to, y);
      ctx.lineTo(to, y + tickDir);
    }

    ctx.stroke();
  }

  // top view fn
  getLineDirectionData(p1, p2) {
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    const length = Math.hypot(dx, dy);

    if (length === 0) {
      return {
        ux: 0,
        uy: 0,
        perpX: 0,
        perpY: 0,
        angle: 0,
        length: 0,
      };
    }

    const ux = dx / length;
    const uy = dy / length;
    const perpX = -uy;
    const perpY = ux;
    const angle = Math.atan2(dy, dx);

    return {
      ux,
      uy,
      perpX,
      perpY,
      angle,
      length,
    };
  }
}

class FrontPanelDrawer extends TopAndFrontSharedDrawer {
  constructor(canvasId, spanKey) {
    super(canvasId);
    this.activeSpanKey = spanKey;
    this.canvas = document.getElementById(canvasId);

    this.sideViewRender();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.setupCommonListeners({
      mode: "side",
      renderCallback: this.sideViewRender,
    });
    // on height change 
    document.querySelectorAll('input[name="railingHeight"]').forEach((input) => {
      input.addEventListener("change", () => {
        this.sideViewRender();
      });
    });
  }

  onAfterShapeChange() {
    this.setupEventListeners();
  }
}

class TopViewDrawer extends TopAndFrontSharedDrawer {
  constructor(canvasId, spanKey) {
    super(canvasId);
    this.activeSpanKey = spanKey;
    this.canvas = document.getElementById(canvasId);

    this.topViewRender();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.setupCommonListeners({
      mode: "top",
      renderCallback: this.topViewRender,
    });
  }

  onAfterShapeChange() {
    this.setupEventListeners();
  }
}

class DetailViewDrawer extends TopAndFrontSharedDrawer {
  constructor(canvasId, spanKey = "A") {
    super(canvasId);
    this.activeSpanKey = spanKey;
    this.detailViewRender();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.setupCommonListeners({
      mode: "detail",
      renderCallback: this.detailViewRender,
    });
  }

  drawShape() {
    const inputs = this.shapeInputs;
    this.drawGrid();
    if (inputs) {
      if (this.selectedShape === "inline") {
        this.drawTopViewShape(); 
      } else if (this.selectedShape === "l_shape") {
        this.drawTopViewShape();
      } else if (this.selectedShape === "u_shape") {
        this.drawTopViewShape();
      }
    }
  }

  getSpanKeysForShape(shape) {
    return {
      inline: ["A"],
      l_shape: ["A", "B"],
      u_shape: ["A", "B", "C"]
    }[shape] || [];
  }

  onAfterShapeChange() {
    this.setupEventListeners();
  }

  detailViewRender() {
    this.drawShape();
  }
}

window.onload = () => {
  const base = new BaseCanvas(); 
  if (!window._viewSwitchingInitialized) {
    base.setupViewSwitching(); 
  }

  // Optionally start with a default view
  window.activeMode = "simple";
  window.drawerInstance = new RailingConfiguratorCanvas("drawingCanvas");
};

// railing configurator different views buttons
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("glass_view_button")) {
    document
      .querySelectorAll(".top-controls .glass_view_button")
      .forEach((btn) => {
        btn.classList.remove("active");
      });

    e.target.classList.add("active");
  }
});

/* --- Railing configurator --- end */

// Preview functionality
document.getElementById("preview").addEventListener("click", function () {
    const canvas = document.querySelector('#drawingCanvas');
    const dataURL = canvas.toDataURL("image/png");
    const previewWindow = window.open("", "Preview", "width=900,height=600");

    // Create an image element
    const img = document.createElement("img");
    img.src = dataURL;
    img.alt = "Canvas Preview";
    img.style.width = "100%";
    img.style.height = "auto";

    // Create a download button
    const downloadButton = document.createElement("button");
    downloadButton.innerText = "Download";
    downloadButton.onclick = function () {
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = "canvas-image.png";
        link.click();
    };

    // Create a close button
    const closeButton = document.createElement("button");
    closeButton.innerText = "Close";
    closeButton.onclick = function () {
        previewWindow.close();
    };

    // Append elements to the preview window's document
    previewWindow.document.body.appendChild(img);
    previewWindow.document.body.appendChild(downloadButton);
    previewWindow.document.body.appendChild(closeButton);

    // Close the document to apply changes
    previewWindow.document.close();
});


let totalPrice = 0;

// jQuery Plugin Definition
(($) => {
    $.fn.railingConfigurator = function(options) {
        const settings = $.extend({
            hardwareOptions: {},
            subHardwareOptions: {},
            glassTypeOptions: {},
            topRailingOptions: {},
            railingHeightOptions: {},
            productTypeOptions: {},
            onStepComplete: (data) => {}
        }, options);

        const data = {
            selectedHardware: null,
            selectedSubHardware: null,
            selectedGlassType: null,
            selectedTopRailing: null,
            selectedRailingHeight: null,
            selectedProductType: null
        };

        const renderOptions = (container, options, name, onChange) => {
            container.empty();
            const parentContainer = container.closest('.inner_content');
            let firstOption = true; // Variable to check if it's the first option
            let selectedOption = '';

            Object.keys(options).forEach(key => {
                const option = options[key];
                container.append(`
                    <label for="${key}" class="rm_radio_input">
                        <input type="radio" name="${name}" id="${key}" value="${key}" ${firstOption ? 'checked' : ''}>
                        <div class="rm_radio_input_img">
                             ${option.image ? `<img src="${option.image}" alt="">` : `<p>${key}</p>`}
                        </div>
                    </label> 
                `);

                if (firstOption) {
                    firstOption = false;
                    data[`selected${capitalizeFirstLetter(name)}`] = key;
                    selectedOption = option;
                }
            });

            parentContainer.find('.option_title, .option_description').remove();
            parentContainer.append(`<h4 class="option_title">${selectedOption.title}</h4>`);

            if(selectedOption.description) {
                parentContainer.append(`<p class="option_description">${selectedOption.description}</p>`);
            }

            $(`input[name="${name}"]`, container).change(onChange);
        };

        const renderHardwareOptions = () => {
            const container = $('#hardwareOptions', this);
            renderOptions(container, settings.hardwareOptions, 'hardware', function() {
                data.selectedHardware = $(this).val();
                const hardwareObject = settings.hardwareOptions[data.selectedHardware];
              
                container.closest('.inner_content').find('.option_title').text(hardwareObject.title);
                container.closest('.inner_content').find('.option_description').text(hardwareObject.description);
                renderPreviewImage();

                //renderSubHardwareOptions(data.selectedHardware);
            });
        };

        const renderSubHardwareOptions = (selectedHardware) => {
            const container = $('#subHardwareOptions', this);

            if (settings.subHardwareOptions[selectedHardware]) {
                renderOptions(container, settings.subHardwareOptions[selectedHardware], 'subHardware', function() {
                    data.selectedSubHardware = $(this).val();
                    container.closest('.inner_content').find('.option_title').text(settings.subHardwareOptions[selectedHardware][data.selectedSubHardware].title);
                    container.closest('.inner_content').find('.option_description').text(settings.subHardwareOptions[selectedHardware][data.selectedSubHardware].description);
                });
            }
        };

        const renderGlassTypeOptions = () => {
            const container = $('#glassTypeOptions', this);
            renderOptions(container, settings.glassTypeOptions.glasses, 'glassType', function() {
                data.selectedGlassType = $(this).val();
                const spec = settings.glassTypeOptions.specifications.find(
                    (spec, index) => Object.keys(settings.glassTypeOptions.glasses)[index] === data.selectedGlassType
                );
                $('#glassTypeSpecs', this).html(`
                    <div>${spec.title}</div>
                    <a href="${spec.pdfLink}" target="_blank">Download Specifications</a>
                `);

                const selectedGlassType = settings.glassTypeOptions.glasses[data.selectedGlassType];
                const parentContainer = container.closest('.inner_content');

                parentContainer.find('.option_title').text(selectedGlassType.title);
                parentContainer.find('.option_desc').text(selectedGlassType.description);

                calculatePrice();
            });
        };

        const renderTopRailingOptions = () => {
            const container = $('#topRailingOptions', this);
            renderOptions(container, settings.topRailingOptions, 'topRailing', function() {
                data.selectedTopRailing = $(this).val();
            });
        };

        const renderRailingHeightOptions = () => {
            const container = $('#railingHeightOptions', this);
            renderOptions(container, settings.railingHeightOptions.heights, 'railingHeight', function() {
                data.selectedRailingHeight = $(this).val();
                container.closest('.inner_content').find('.option_title').text(settings.railingHeightOptions.heights[data.selectedRailingHeight].title);
                calculatePrice();
            });

             if(railingHeightOptions.description) {
              container.closest('.inner_content').find('.option_title').after(railingHeightOptions.description);
            }
        };

        const renderProductTypeTemplates = (selectedProductType) => {
            const container = $('#productTypeTemplateOptions', this);

            if (settings.productTypeOptions[selectedProductType].templates) {
                $('#templateOptionContainer').show();
                renderOptions(container, settings.productTypeOptions[selectedProductType].templates, 'productTypeTemplate', function() {
                    data.selectedProductTypeTemplate = $(this).val();
                    const templates = settings.productTypeOptions[selectedProductType]['templates'];

                    container.closest('.inner_content').find('.option_title').text(templates[data.selectedProductTypeTemplate].title);
                    container.closest('.inner_content').find('.option_description').text(templates[data.selectedProductTypeTemplate].description);

                    renderProductTemplateSpans();
                    // refreshCanvas(data.selectedProductTypeTemplate);
                });

                renderProductTemplateSpans();
                // refreshCanvas(data.selectedProductTypeTemplate);
            }
          else{
            $('#templateOptionContainer').hide();
          }

          calculatePrice();
        }

        const renderProductTypes = () => {
          const container = $('#productTypeOptions', this);
          renderOptions(container, settings.productTypeOptions, 'productType', function() {
              data.selectedProductType = $(this).val();
              renderProductTypeTemplates(data.selectedProductType);
          });
        }

        const validateHardwareStep = () => {
            if (!data.selectedHardware || !data.selectedSubHardware || !data.selectedGlassType || 
                !data.selectedTopRailing || !data.selectedRailingHeight) {
                alert("Please complete all selections.");
                return false;
            }
            return true;
        };

         const capitalizeFirstLetter = (string) => {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };

        const getSpanCount = (selectedTemplate) => {
            let spanCount = 0;

            if (selectedTemplate === 'inline') {
              spanCount = 1;
            } else if (selectedTemplate === 'l_shape') {
              spanCount = 2;
            } else if (selectedTemplate === 'u_shape') {
              spanCount = 3;
            }

            return spanCount;
        }

        const renderProductTemplateSpans = () => {
            __selectedShape = data.selectedProductTypeTemplate;
            const selectedTemplate = data.selectedProductTypeTemplate;
            const spanCount = getSpanCount(selectedTemplate);
            createSpans(spanCount);
        }

        // Function to calculate the minimum and maximum number of panels
        const calculateNumPanels = (length) => {
            const smallestPanel = 19.30;
            const min = Math.ceil(length / 64); // Max size panel
            const max = Math.floor(length / smallestPanel); // Min size panel
            return [min, max];
        }
    
        // Function to calculate the panel size based on the total length and panel count
        const calculatePanelSize = (length, panelCount, spacing = 0.75) => {
            return ((length - (panelCount + spacing)) / panelCount).toFixed(3);
        }
    
        // Function to populate select box with panel sizes
        const getSelectBoxOptions = (panelSizes) => {
            let options = '';

            if (panelSizes.length > 0) {
                panelSizes.forEach((size, panelCount) => {
                    if (size !== undefined) { // Ensure valid sizes
                        const option = `<option value="${panelCount}" data-panel-size="${size}">${panelCount} - ${size}&quot;</option>`;
                        options += option;
                    }
                });
            }

            return options;
        };
    
        // Function to handle panel size calculations and updating the select box
        const getPanelOptions = (length) => {
            if (isNaN(length) || length <= 0) {
                //@TODO throw error
                return;
            }

            // Calculate the minimum and maximum panel counts
            const [min, max] = calculateNumPanels(length);
    
            // Calculate panel sizes based on the panel counts
            let panelSizes = [];
            for (let panelCount = min; panelCount <= max; panelCount++) {
                panelSizes[panelCount] = calculatePanelSize(length, panelCount);
            }
    
            // Populate the select box with the calculated panel sizes
            return getSelectBoxOptions(panelSizes);
        }
      
        // This goes OUTSIDE the loop – you only generate it ONCE
        const topButtonsHtml = (spanNames) => {
          const sideButtons = spanNames.map(name => (
            `<button class="sidePanelView-${name} button glass_view_button" style="white-space: nowrap;">Side span ${name}</button>`
          )).join(' ');
        
          return `
            <div class="top-controls" style="margin-bottom: 20px; display: flex; overflow-x: auto; gap: 10px; padding: 15px 0;">
              <button class="simple_view active button glass_view_button" style="white-space: nowrap;">Simple View</button>
              <button class="top_view button glass_view_button" style="white-space: nowrap;">Top View</button>
              <button class="detail_view button glass_view_button" style="white-space: nowrap;">Detail View</button>
              ${sideButtons}
            </div>
          `;
        };

        const spanHtml = (spanName, spanNumber) => {
          const length = 200;
          const panelOptions = getPanelOptions(length);

          return ` 
                <h3 class="steps_heading">Span ${spanName} Panels</h3>
                <div id="span-${spanNumber}" class="combine_div">
                <div class="form-group measurement w-100">
                    <div class="d-flex justify-content-between align-center">
                        <label for="overall-length" class="input_label"> Span Length </label>
                        <span class="inch">inch</span>
                    </div>
                    <div class="form_input d-flex justify-content-between">
                    <input type="number" class="form-control config-input w-100" id="overall-length-${spanNumber}" value="${length}">
                    <select class="form-control config-input w-50">
                        <option value="0">0"</option>
                        <option value="1/16">1/16"</option>
                        <option value="1/8">1/8"</option>
                        <option value="3/16">3/16"</option>
                        <option value="1/4">1/4"</option>
                        <option value="5/16">5/16"</option>
                        <option value="3/8">3/8"</option>
                        <option value="7/16">7/16"</option>
                        <option value="1/2">1/2"</option>
                        <option value="9/16">9/16"</option>
                        <option value="5/8">5/8"</option>
                        <option value="11/16">11/16"</option>
                        <option value="3/4">3/4"</option>
                        <option value="13/16">13/16"</option>
                        <option value="7/8">7/8"</option>
                        <option value="15/16">15/16"</option>
                    </select>
                    </div>
                </div>
              <div class="form-group w-100">
                <div class="d-flex justify-content-between align-center">
                  <label for="thread-depth" class="input_label">
                    Number Of Panels
                  </label>
                </div>
                <div class="form_input d-flex justify-content-between">
                  <select id="num_panels_span_${spanNumber}" class="form-control config-input w-100 num_panels">
                    ${panelOptions}
                  </select>
                </div>
              </div>
            </div>`;
        }

       const createSpans = (spanCount) => {
          let html = '';
          let spanNames = []; 

          for (let i = 1; i <= spanCount; i++) {
            const spanChar = String.fromCharCode(64 + i); 
            spanNames.push(spanChar);
            html += spanHtml(String.fromCharCode(64 + i), i);
          }
        
          const topHtml = topButtonsHtml(spanNames); 
        
          $('#spans-container').html(topHtml + html); 
         
          calculatePrice();

          $('.measurement input').change(function() {
            const length = $(this).val();
            const panelOptions = getPanelOptions(length);
            const selectBox = $(this).closest('.combine_div').find('.num_panels');

            selectBox.html(panelOptions);
            // refreshCanvas(data.selectedProductTypeTemplate);
            calculatePrice();
          });

         $('.num_panels').change(function() {
            // refreshCanvas(data.selectedProductTypeTemplate);
            calculatePrice();
          });
        }

        const getGlassThicknessMultiplier = () => {
          return settings.glassTypeOptions.glasses[data.selectedGlassType].multiplier || 1;
        }

        // Main pricing calculation function
        const calculatePrice = () => {
          createOrderSummary(data);

          const spanCount = getSpanCount(data.selectedProductTypeTemplate);
          let spanPrice = 0;

          for (let i = 1; i <= spanCount; i++) {
             spanPrice += calculateSpanPrice(i);
          }

          const hardwarePrice = getHardwarePrice();

          totalPrice = (spanPrice + hardwarePrice).toFixed(2);
          const formattedPrice = formatPriceShopify(totalPrice);

          $('.product--price').text(formattedPrice);

          return totalPrice;
        }

        const calculateSpanPrice = (span) => {
          const height = data.selectedRailingHeight;
          const length = $(`#overall-length-${span}`).val();

          const thicknessMultiplier = getGlassThicknessMultiplier();

          return height * length * thicknessMultiplier;
        }

        // Function to calculate hardware price, can be extended in the future
        const getHardwarePrice = () => {
          const hardwarePrice = 0;
          return hardwarePrice;
        }

        const renderPreviewImage = () => {
            const hardwareObject = settings.hardwareOptions[data.selectedHardware];
            $('#productPreviewImg').attr('src', hardwareObject.image);
        }

        const formatPriceShopify = (price) => {
          return `$${Number(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
        }

        const callback = function(){
           calculatePrice();
        }

        const getMeasurementHtml = () => {
          const spanCount = getSpanCount(data.selectedProductTypeTemplate);
          let html = '';

          for (let i = 1; i <= spanCount; i++) {
              const spanLength = $(`#overall-length-${i}`).val();

              // Select the selected option for the number of panels
              const selectedOption = $(`#num_panels_span_${i}`).find('option:selected');
              const numPanels = selectedOption.val();
              const panelLength = selectedOption.data('panel-size');

              // Check if panelLength and numPanels are valid
              if (!numPanels || !panelLength) {
                  console.warn(`Panel data missing for span ${i}`);
                  continue; // Skip to the next iteration if data is missing
              }

              const optionName = `Span ${String.fromCharCode(64 + i)}`;
              const optionValue = `${spanLength}" length with ${numPanels} panels, ${panelLength}" each`;

              html += `
                  <li>
                      <strong>${optionName}</strong>
                      <span>${optionValue}</span>
                      <a href="javascript:void(0);" onclick="openStep(3);">EDIT</a>
                  </li>
              `;

              productProperties[optionName] = optionValue;
          }

          return html;
        };

        $('#calculatePrice').click(callback);

        let productProperties = {};

        const createOrderSummary = (selectedOptions) => {
            const $orderSummary = $('#order-summary');
            $orderSummary.empty(); // Clear any existing items in the list

            // Define the items for each step, with selected coming from selectedOptions
            const items = [
                { title: 'Hardware', option_selected: settings.hardwareOptions[selectedOptions.selectedHardware].title  || '', onclickStep: 1 },
                { title: 'Glass Type', option_selected: settings.glassTypeOptions.glasses[selectedOptions.selectedGlassType].title || '', onclickStep: 1 },
                { title: 'Top Rail Options', option_selected: settings.topRailingOptions[selectedOptions.selectedTopRailing].title || '', onclickStep: 1 },
                { title: 'Railing height', option_selected: settings.railingHeightOptions.heights[selectedOptions.selectedRailingHeight].title || '', onclickStep: 1 },
                { title: 'Product Type', option_selected: settings.productTypeOptions[selectedOptions.selectedProductType].title || '', onclickStep: 2 },
                { title: 'Template', option_selected: getFramelessRailingTemplates()[selectedOptions.selectedProductTypeTemplate]?.title || "", onclickStep: 2 },
                //{ title: 'Measurements', option_selected: selectedOptions.template || '', onclickStep: 3 }
            ];

            // Loop through all items and append them to the order summary list
            items.forEach(item => {
                $orderSummary.append(`
                    <li>
                        <strong>${item.title}</strong>
                        <span>${item.option_selected}</span>
                        <a href="javascript:void(0);" onclick="openStep(${item.onclickStep});">EDIT</a>
                    </li>
                `);

                productProperties[item.title] = item.option_selected;
            });

            const measurementHtml = getMeasurementHtml();
            $orderSummary.append(measurementHtml);
        }

        $('.add-to-cart').click(function () {
            $(this).addClass('loading');
            const title = 'Frameless Railing System';

            const data = {
                title: title,
                price: totalPrice,
                properties: productProperties
            };

            const params = {
                type: 'POST',
                url: createShopifyProductUrl,
                data: data,
                dataType: "json"
            };

            $.ajax(params)
            .done(
                function(response) {
                    var id = response.product.variants[0].id;
                    var product_id = response.product.id;
    
                    //Product created using shopify admin api.. add to cart it now.
                    addToCart(id, productProperties);
                }.bind(this)
            )
            .fail(
                function(response) {
                    console.log(response);
                }.bind(this)
            );
        });

        return this.each(function() {
            const self = $(this);

            // Initialization
            renderHardwareOptions.call(self);
            renderPreviewImage.call(self);
            renderSubHardwareOptions.call(self, data.selectedHardware);
            renderGlassTypeOptions.call(self);
            renderTopRailingOptions.call(self);
            renderRailingHeightOptions.call(self);
            renderProductTypes.call(self);
            renderProductTypeTemplates.call(self, data.selectedProductType);

            $('#nextButton', self).click(() => {
                if (validateHardwareStep()) {
                    settings.onStepComplete(data);
                    // Move to the next step
                }
            });
        });
    };
})(jQuery);

// Define your demo data
const hardwareOptions = {
    'brushed_nickel': {
        title: 'Duplex Stainless - Brushed Nickel',
        image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/railing-hardware-brushed-nickel.png?v=1725951388',
        description: ''
    },
    'chrome': {
        title: 'Duplex Stainless - Chrome',
        image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/railing-hardware-chrome.png?v=1725951355',
        description: ''
    },
    'matte_black': {
        title: 'Duplex Stainless - Matte Black',
        image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/railing-hardware-matte-black.png?v=1725951375',
        description: ''
    }
};

const subHardwareOptions = {
    'brushed_nickel': {
        'sub1': {
            title: 'Duplex Stainless-Steel Surface Mount Spigot - Polished Stainless R-SP-2205SS-1',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 1'
        },
        'sub2': {
            title: 'Duplex Stainless-Steel Surface Mount Spigot - Matte Black R-SP-2205MB-1',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 2'
        }
    },
    'chrome': {
        'sub3': {
            title: 'Duplex Stainless-Steel Side Mounted Spigots - Polished Stainless R-SM-2205SS',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 3'
        },
        'sub4': {
            title: 'Duplex Stainless-Steel Side Mounted Spigots - Matte Black R-SM-2205MB',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 4'
        }
    },
    'matte_black': {
        'sub5': {
            title: 'GS Adjustable Standoff 1-1/2" Base Height - Polished Stainless R-ST-AJ-150D150HSS',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 5'
        },
        'sub6': {
            title: 'GS Adjustable Standoff 1-1/2" Base Height - Matte Black R-ST-AJ-150D150HMB',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 6'
        },
        'sub7': {
            title: 'GS Adjustable Standoff 1-1/4" Base Height - Polished Stainless R-ST-AJ-150D125HSS',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 7'
        },
        'sub8': {
            title: 'GS Adjustable Standoff 1-1/4" Base Height - Matte Black R-ST-AJ-150D125HMB',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 8'
        },
        'sub9': {
            title: 'Glass Rail Adjustable Standoff – 2" Base Height - Polished Stainless R-ST-AJ-150D2HSS',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 9'
        },
        'sub10': {
            title: 'Glass Rail Adjustable Standoff – 2" Base Height - Matte Black R-ST-AJ-150D2HMB',
            image: 'https://www.royaltymirror.com/cdn/shop/files/doublepanewindowreplacement-2_360x.webp',
            description: 'Description for Sub Hardware 10'
        }
    }
};

const glassTypeOptions = {
    glasses: {
        '1-2-clear-tempered': {
            title: '1/2" Clear Tempered Glass', 
            image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/3_0e2adc2b-b404-4713-9d0a-fa59354b80dd.png', 
            description: 'Tempered Glass',
            multiplier : 0.312
        }
    }
};

const topRailingOptions = {
    'no_top_rail': {
        title: 'Fully Frameless Railing',
        image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/no-frame-railings.jpg?v=1725963469',
        description: 'Get clear views without sacrificing safety.'
    }
};

const railingHeightOptions = {
    heights: {
        36: { title: '36 Inches' },
        42: { title: '42 Inches' },
        48: { title: '48 Inches' },
        60: { title: '60 Inches' }
    },
    description: `<div class="railing_height d-flex align-center">
                   <div class="r_icon">
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4706 48L20.1176 48.0002C19.0256 48.0002 17.9782 47.6256 17.206 46.9588C16.4338 46.292 16 45.3877 16 44.4447V19.5556C16 18.6126 16.4338 17.7082 17.206 17.0415C17.9782 16.3747 19.0256 16.0001 20.1176 16.0001H23.4706M41.8237 35.5556V48M41.8237 48L35.6473 42.6667M41.8237 48L48.0002 42.6667M41.8237 48H31.6473M41.8237 48H52.0002M41.8237 16V28.4444M41.8237 16L35.6473 21.3333M41.8237 16L48.0002 21.3333" stroke="#A3B4CC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><rect x="7.5" y="22.5" width="15" height="19" rx="3.5" fill="white"></rect><path d="M18.4932 36H17.2972L14.9702 32.464L12.6302 36H11.4212L14.4242 31.632L11.6812 27.42H12.9032L15.0742 30.761L17.2712 27.42H18.4022L15.6202 31.58L18.4932 36Z" fill="#07080A"></path><rect x="7.5" y="22.5" width="15" height="19" rx="3.5" stroke="#455266"></rect></svg>
                   </div>
                   <div class="r_height_text">
                     <p>Railing height is a measurement from the deck or floor surface to top edge of a glass panel</p>
                   </div>
                 </div>`,
    how_to_measure: 'Instructions on how to measure the railing height'
};

const getFramelessRailingTemplates = () => {
   return {
     'inline': {
       title: 'Inline',
       image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/shape_1.jpg',
       description: ''
     },
     'l_shape': {
       title: 'L Shape',
       image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/shape_2.jpg',
       description: ''
     },
     'u_shape': {
       title: 'U Shape',
       image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/shape_3.jpg',
       description: ''
     }
   }
}

const productTypeOptions = {
    'frameless_railing_system': {
        title: 'Frameless Railing System',
        image: 'https://cdn.shopify.com/s/files/1/0507/2597/8291/files/no-frame-railings.jpg?v=1725963469',
        description: '',
        templates: getFramelessRailingTemplates()
    }
};

// Initialize the configurator plugin
$('#railingsConfigurator').railingConfigurator({
    hardwareOptions: hardwareOptions,
    subHardwareOptions: {},
    glassTypeOptions: glassTypeOptions,
    topRailingOptions: topRailingOptions,
    railingHeightOptions: railingHeightOptions,
    productTypeOptions: productTypeOptions,
    onStepComplete: (data) => {
        console.log("Hardware step completed with data:", data);
        // Proceed to the next step or other actions
    }
});